var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types/design.ts
var MOOD_GUIDANCE;
var init_design = __esm({
  "src/types/design.ts"() {
    MOOD_GUIDANCE = {
      "Modern": "Clean lines, ample white space, contemporary patterns",
      "Professional": "Polished, consistent, attention to detail",
      "Playful": "Rounded shapes, friendly interactions, lighthearted touches",
      "Minimal": "Essential elements only, generous spacing, restrained palette use",
      "Luxurious": "Premium feel, refined details, sophisticated presentation",
      "Trustworthy": "Clear hierarchy, readable typography, familiar patterns",
      "Friendly": "Approachable, warm colors, inviting interactions",
      "Bold": "Strong contrasts, large typography, confident visual statements",
      "Elegant": "Refined details, subtle transitions, sophisticated spacing",
      "Energetic": "Vibrant colors, dynamic layouts, active feeling",
      "Clean": "Uncluttered, focused, clear visual hierarchy",
      "Sophisticated": "Refined aesthetics, balanced composition, mature style",
      "Vibrant": "Rich colors, high energy, lively presence",
      "Warm": "Inviting colors, soft edges, approachable feel",
      "Tech-forward": "Sharp edges, monospace accents, futuristic elements"
    };
  }
});

// src/config/tags.ts
function findTagDefinition(key) {
  for (const def of TAG_DEFINITIONS) {
    if (def.key === key) return def;
    if (def.children) {
      const child = def.children.find((c) => c.key === key);
      if (child) return child;
    }
  }
  return void 0;
}
var TAG_DEFINITIONS;
var init_tags = __esm({
  "src/config/tags.ts"() {
    TAG_DEFINITIONS = [
      // Model Selection (explicit provider + model mapping)
      {
        key: "model",
        label: "Model",
        description: "AI agent and model to use for generation",
        category: "model",
        inputType: "select",
        options: [
          {
            value: "claude-sonnet-5",
            label: "Claude Sonnet 5",
            description: "Anthropic Claude - Best balance of speed and intelligence",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-sonnet-5",
            sdk: "agent"
          },
          {
            value: "claude-opus-4-8",
            label: "Claude Opus 4.8",
            description: "Anthropic Claude - Most capable for complex tasks",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-opus-4-8",
            sdk: "agent"
          },
          {
            value: "claude-haiku-4-5",
            label: "Claude Haiku 4.5",
            description: "Anthropic Claude - Fastest, good for iterations",
            logo: "/claude.png",
            provider: "claude-code",
            model: "claude-haiku-4-5",
            sdk: "agent"
          },
          {
            value: "gpt-5.2-codex",
            label: "GPT-5.2 Codex",
            description: "OpenAI Codex - Advanced code generation",
            logo: "/openai.png",
            provider: "openai-codex",
            model: "openai/gpt-5.2-codex",
            sdk: "agent"
          },
          {
            value: "factory-droid-opus",
            label: "Factory Droid (Opus)",
            description: "Factory Droid SDK with Claude Opus 4.8",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "claude-opus-4-8",
            sdk: "droid"
          },
          {
            value: "factory-droid-codex",
            label: "Factory Droid (Codex)",
            description: "Factory Droid SDK with GPT-5.2 Codex",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "gpt-5.2-codex",
            sdk: "droid"
          },
          {
            value: "factory-droid-glm",
            label: "Factory Droid (GLM)",
            description: "Factory Droid SDK with GLM 4.7",
            logo: "/factory.svg",
            provider: "factory-droid",
            model: "glm-4.7",
            sdk: "droid"
          }
        ]
      },
      // Framework Selection
      {
        key: "framework",
        label: "Framework",
        description: "Frontend framework to use",
        category: "framework",
        inputType: "select",
        options: [
          {
            value: "next",
            label: "Next.js",
            description: "Full-stack React with SSR, App Router, and file-based routing",
            logo: "/logos/nextjs.svg",
            repository: "github:codyde/template-nextjs",
            branch: "main"
          },
          {
            value: "tanstack",
            label: "TanStack Start",
            description: "Minimal TanStack Start foundation with React 19, Router, Query, and Tailwind",
            logo: "/logos/tanstack.png",
            repository: "github:codyde/template-tanstackstart",
            branch: "main"
          },
          {
            value: "vite",
            label: "React + Vite",
            description: "Fast React SPA with Vite - perfect for client-side apps",
            logo: "/logos/react.svg",
            repository: "github:codyde/template-reactvite",
            branch: "main"
          }
        ],
        promptTemplate: "CRITICAL: You MUST use the {label} template. Clone it using: npx degit {repository}#{branch} {{projectName}}"
      },
      // Runner Selection (options populated dynamically)
      {
        key: "runner",
        label: "Runner",
        description: "Build runner to execute the build",
        category: "runner",
        inputType: "select",
        options: []
        // Populated dynamically from connected runners
      },
      // Design Configuration (nested)
      {
        key: "design",
        label: "Design",
        description: "Visual design preferences",
        category: "design",
        inputType: "nested",
        children: [
          // Brand Themes
          {
            key: "brand",
            label: "Brand",
            description: "Pre-configured brand color themes",
            category: "design",
            inputType: "select",
            maxSelections: 1,
            options: [
              {
                value: "stripe",
                label: "Stripe",
                description: "Modern payments aesthetic",
                logo: "/logos/stripe.svg",
                values: {
                  primaryColor: "#635bff",
                  secondaryColor: "#0a2540",
                  accentColor: "#00d4ff",
                  neutralLight: "#f6f9fc",
                  neutralDark: "#0a2540"
                }
              },
              {
                value: "vercel",
                label: "Vercel",
                description: "Clean developer tools",
                logo: "/logos/vercel.svg",
                values: {
                  primaryColor: "#000000",
                  secondaryColor: "#ffffff",
                  accentColor: "#0070f3",
                  neutralLight: "#fafafa",
                  neutralDark: "#000000"
                }
              },
              {
                value: "linear",
                label: "Linear",
                description: "Sleek project management",
                logo: "/logos/linear.svg",
                values: {
                  primaryColor: "#5e6ad2",
                  secondaryColor: "#26b5ce",
                  accentColor: "#f2994a",
                  neutralLight: "#f7f8f8",
                  neutralDark: "#1a1a1a"
                }
              },
              {
                value: "notion",
                label: "Notion",
                description: "Warm productivity",
                logo: "/logos/notion.svg",
                values: {
                  primaryColor: "#2383e2",
                  secondaryColor: "#e69138",
                  accentColor: "#d44c47",
                  neutralLight: "#f7f6f3",
                  neutralDark: "#37352f"
                }
              },
              {
                value: "github",
                label: "GitHub",
                description: "Developer-first",
                logo: "/logos/github.svg",
                values: {
                  primaryColor: "#238636",
                  secondaryColor: "#1f6feb",
                  accentColor: "#f85149",
                  neutralLight: "#f6f8fa",
                  neutralDark: "#24292f"
                }
              },
              {
                value: "airbnb",
                label: "Airbnb",
                description: "Friendly travel",
                logo: "/logos/airbnb.svg",
                values: {
                  primaryColor: "#ff385c",
                  secondaryColor: "#00a699",
                  accentColor: "#fc642d",
                  neutralLight: "#f7f7f7",
                  neutralDark: "#222222"
                }
              },
              {
                value: "spotify",
                label: "Spotify",
                description: "Bold music streaming",
                logo: "/logos/spotify.svg",
                values: {
                  primaryColor: "#1db954",
                  secondaryColor: "#191414",
                  accentColor: "#1ed760",
                  neutralLight: "#f6f6f6",
                  neutralDark: "#000000"
                }
              }
            ],
            promptTemplate: "Use the {value} brand aesthetic with the following color palette: Primary: {primaryColor}, Secondary: {secondaryColor}, Accent: {accentColor}, Neutral Light: {neutralLight}, Neutral Dark: {neutralDark}. Match the design style and feel of {value}."
          }
        ]
      }
    ];
  }
});

// src/lib/tags/resolver.ts
function resolveTags(appliedTags) {
  const resolved = {};
  try {
    if (!appliedTags || !Array.isArray(appliedTags)) {
      console.warn("[resolveTags] Invalid appliedTags:", appliedTags);
      return resolved;
    }
    const brandTag = appliedTags.find((t) => t.key === "brand");
    if (brandTag?.expandedValues) {
      Object.assign(resolved, brandTag.expandedValues);
      resolved.brand = brandTag.value;
    }
    const modelTag = appliedTags.find((t) => t.key === "model");
    if (modelTag) {
      resolved.model = modelTag.value;
    }
    const frameworkTag = appliedTags.find((t) => t.key === "framework");
    if (frameworkTag) {
      resolved.framework = frameworkTag.value;
    }
    const runnerTag = appliedTags.find((t) => t.key === "runner");
    if (runnerTag) {
      resolved.runner = runnerTag.value;
    }
    return resolved;
  } catch (error) {
    console.error("[resolveTags] Error resolving tags:", error);
    return resolved;
  }
}
function generatePromptFromTags(resolved, projectName, isNewProject) {
  const sections = [];
  sections.push(`\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550
\u{1F3AF} USER-SPECIFIED DESIGN (HIGHEST PRIORITY - OVERRIDES ALL DEFAULTS)
\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550

CRITICAL PRIORITY LEVELS:
[PRIORITY 1] User's explicit tag selections (below) - MUST be implemented exactly
[PRIORITY 2] Template functionality and structure - keep this  
[PRIORITY 3] Base design system defaults - use only if no tags specified

${isNewProject ? `
\u26A0\uFE0F  TEMPLATE TRANSFORMATION REQUIRED \u26A0\uFE0F

You are working with a template that has its own existing design.
Your job: TRANSFORM the template's visual design to match the specifications below.

DO NOT just add styles on top - REPLACE the template's design language:
- Modify the template's CSS/styling files 
- Update component designs (buttons, cards, layouts, navigation)
- Change visual aesthetics while preserving functionality
- The template STRUCTURE is fine, but its VISUAL DESIGN must change
` : ""}`);
  if (resolved.framework) {
    const frameworkDef = findTagDefinition("framework");
    const frameworkOption = frameworkDef?.options?.find((o) => o.value === resolved.framework);
    if (frameworkOption && frameworkDef?.promptTemplate) {
      let prompt = frameworkDef.promptTemplate.replace("{label}", frameworkOption.label).replace("{value}", frameworkOption.value).replace("{repository}", frameworkOption.repository || "").replace("{branch}", frameworkOption.branch || "main").replace("{{projectName}}", projectName || "<project-name>");
      sections.push(`## Framework Requirement (MANDATORY)

${prompt}`);
    } else {
      sections.push(`## Framework Requirement (MANDATORY)

CRITICAL: The user has explicitly selected ${resolved.framework} as the framework.
You MUST use ${resolved.framework} for this project. Do NOT suggest or use any other framework.

Set up the project structure according to ${resolved.framework} best practices and conventions.`);
    }
  }
  if (resolved.brand) {
    sections.push("\n## Design Constraints (MANDATORY - User-Specified)\n");
    sections.push("CRITICAL: The user has explicitly configured these design preferences. Follow these specifications precisely:\n");
    const brandDef = findTagDefinition("brand");
    const brandOption = brandDef?.options?.find((o) => o.value === resolved.brand);
    if (brandOption) {
      sections.push(`**Brand Aesthetic (MANDATORY):**`);
      sections.push(`Match the visual style and feel of ${brandOption.label} (${brandOption.description}).`);
    }
    sections.push(`
**Color Palette (MANDATORY - DO NOT DEVIATE):**`);
    sections.push(`- Primary: ${resolved.primaryColor} (use for CTAs, primary buttons, brand elements)`);
    sections.push(`- Secondary: ${resolved.secondaryColor} (use for secondary actions, supporting elements)`);
    sections.push(`- Accent: ${resolved.accentColor} (use for highlights, badges, important elements)`);
    sections.push(`- Neutral Light: ${resolved.neutralLight} (use for light backgrounds, cards, containers)`);
    sections.push(`- Neutral Dark: ${resolved.neutralDark} (use for text, dark backgrounds, borders)`);
    sections.push(`
You MUST use ONLY these 5 colors. Do NOT introduce any additional colors outside this palette.`);
    sections.push("\n**Technical Requirements:**");
    sections.push("- Define all colors as CSS custom properties (e.g., --color-primary, --color-secondary)");
    sections.push("- NEVER hardcode hex values directly in components");
    sections.push("- Use semantic color names that reference the custom properties");
    sections.push("- NEVER use emojis in the UI. Instead, use Lucide React icons for all visual elements");
  } else {
    sections.push("\n**UI Guidelines:**");
    sections.push("- NEVER use emojis in the UI. Instead, use Lucide React icons for all visual elements");
  }
  return sections.filter((s) => s).join("\n");
}
var init_resolver = __esm({
  "src/lib/tags/resolver.ts"() {
    init_tags();
  }
});

// src/lib/agents/claude-strategy.ts
var claude_strategy_exports = {};
__export(claude_strategy_exports, {
  default: () => claude_strategy_default
});
function buildClaudeSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  } else if (context.designPreferences) {
    const prefs = context.designPreferences;
    const moodGuidance = prefs.mood.map((m) => `- ${m}: ${MOOD_GUIDANCE[m] || ""}`).join("\n");
    sections.push(`## Design Constraints (User-Specified)

CRITICAL: The user has specified EXACT design preferences. Follow these specifications precisely:

**Color Palette (MANDATORY - DO NOT DEVIATE):**
- Primary: ${prefs.colors.primary} (use for CTAs, primary buttons, brand elements)
- Secondary: ${prefs.colors.secondary} (use for secondary actions, supporting elements)
- Accent: ${prefs.colors.accent} (use for highlights, badges, important elements)
- Neutral Light: ${prefs.colors.neutralLight} (use for light backgrounds, cards, containers)
- Neutral Dark: ${prefs.colors.neutralDark} (use for text, dark backgrounds, borders)

You MUST use ONLY these colors. Define them as CSS custom properties in your design system:

\`\`\`css
:root {
  --color-primary: ${prefs.colors.primary};
  --color-secondary: ${prefs.colors.secondary};
  --color-accent: ${prefs.colors.accent};
  --color-neutral-light: ${prefs.colors.neutralLight};
  --color-neutral-dark: ${prefs.colors.neutralDark};
}
\`\`\`

**Typography (MANDATORY):**
- Heading Font: ${prefs.typography.heading} (use for all h1, h2, h3, h4, h5, h6)
- Body Font: ${prefs.typography.body} (use for paragraphs, labels, body text, UI elements)

Import these fonts from Google Fonts or use system fonts as specified.

**Style Direction:**
The user wants a design that feels: ${prefs.mood.join(", ")}

Interpret these mood descriptors to guide your design decisions:
${moodGuidance}

**Critical Reminders:**
- Do NOT add any colors outside the specified 5-color palette
- Do NOT use any fonts other than the 2 specified
- Match the mood descriptors in your typography scale, spacing, and component design
- Define colors as CSS variables, never use hex values directly in components`);
  }
  if (context.isNewProject) {
    sections.push(`## New Project: Template Prepared

- Project name: ${context.projectName}
- Location: ${context.workingDirectory}
- Operation type: ${context.operationType}

The template has already been downloaded. Customize the scaffold to satisfy the request; follow the dependency-state instructions below for installation.`);
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Operation type: ${context.operationType}

Review the current codebase and apply the requested changes without re-scaffolding.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      existingProjectSection += `You have access to the recent conversation history. Use this to understand the context and what has been discussed:

`;
      context.conversationHistory.forEach((msg, index2) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const timestamp2 = msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp;
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index2 + 1}. ${roleLabel} (${timestamp2}):
${content}

`;
      });
      existingProjectSection += `Use this conversation history to understand:
- What has been built or discussed so far
- The user's preferences and requirements
- References to "it", "the app", "the project", etc.
- Any previous decisions or implementations

Apply the current request in the context of this conversation.`;
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- Use relative paths within the project.
- Work inside the existing project structure.
- Provide complete updates without placeholders.`);
  if (context.fileTree) {
    sections.push(`## Project Manifest
${context.fileTree}`);
  }
  if (context.templateName) {
    sections.push(`## Template Details
- Template: ${context.templateName}
- Framework: ${context.templateFramework ?? "unknown"}`);
  }
  return sections;
}
function buildFullPrompt(context, basePrompt) {
  if (!context.isNewProject) {
    if (context.operationType === "autofix") {
      return `${basePrompt}

## Autofix Speed Rules
1. Diagnose from the error first; only open files implicated by the stack/log.
2. Make the smallest fix that restores startup; avoid refactors and design changes.
3. Re-run the failing command once, fix remaining errors, then stop.`;
    }
    return basePrompt;
  }
  return `${basePrompt}

CRITICAL: The template has already been prepared in ${context.workingDirectory}. Do not scaffold a new project.

## Speed Rules
1. Emit one short TodoWrite plan (\u22648 items), then implement immediately.
2. Use WebSearch/WebFetch only for missing external docs/API details; do not explore alternative architectures.
3. One dependency install after package.json changes; one build/typecheck; fix only real failures.
4. Finish when the request is met and validation is clean \u2014 no extra polish turns.`;
}
var claudeStrategy, claude_strategy_default;
var init_claude_strategy = __esm({
  "src/lib/agents/claude-strategy.ts"() {
    init_design();
    init_resolver();
    claudeStrategy = {
      buildSystemPromptSections: buildClaudeSections,
      buildFullPrompt,
      shouldDownloadTemplate(context) {
        return context.isNewProject && !context.skipTemplates;
      },
      postTemplateSelected(context, template) {
        context.templateName = template.name;
        context.templateFramework = template.framework;
        context.fileTree = template.fileTree;
      }
    };
    claude_strategy_default = claudeStrategy;
  }
});

// src/lib/agents/codex/template-catalog.ts
function buildCodexTemplateCatalogSection(catalog) {
  return `## Template Catalog
${catalog}`;
}
var init_template_catalog = __esm({
  "src/lib/agents/codex/template-catalog.ts"() {
  }
});

// src/lib/agents/codex/events.ts
function sortPhases(phases) {
  return [...phases].sort((a, b) => {
    const idxA = CODEX_PHASE_ORDER.indexOf(a.id);
    const idxB = CODEX_PHASE_ORDER.indexOf(b.id);
    const safeA = idxA === -1 ? CODEX_PHASE_ORDER.length + 1 : idxA;
    const safeB = idxB === -1 ? CODEX_PHASE_ORDER.length + 1 : idxB;
    if (safeA === safeB) {
      return (a.title ?? "").localeCompare(b.title ?? "");
    }
    return safeA - safeB;
  });
}
function toStringOr(value, fallback) {
  if (value === void 0 || value === null) return fallback;
  return String(value);
}
function toOptionalString(value) {
  if (value === void 0 || value === null) return void 0;
  return String(value);
}
function toOptionalStringArray(values) {
  if (!Array.isArray(values)) return void 0;
  const mapped = values.map((value) => toOptionalString(value)?.trim()).filter((item) => !!item);
  return mapped.length > 0 ? mapped : void 0;
}
function processCodexEvent(state, rawEvent) {
  const timestampValue = rawEvent.timestamp;
  const timestamp2 = timestampValue ? new Date(timestampValue) : /* @__PURE__ */ new Date();
  switch (rawEvent.type) {
    case "codex-phase-start": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      let found = false;
      const phases = state.phases.map((phase) => {
        if (phase.id === phaseId) {
          found = true;
          return {
            ...phase,
            title: toOptionalString(rawEvent.title) ?? phase.title,
            description: toOptionalString(rawEvent.description) ?? phase.description,
            status: "active",
            startedAt: phase.startedAt ?? timestamp2,
            spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight
          };
        }
        if (phase.status === "active" && phase.completedAt === void 0) {
          return {
            ...phase,
            status: "completed",
            completedAt: timestamp2
          };
        }
        return phase;
      });
      const next = found ? phases : [
        ...phases,
        {
          id: phaseId,
          title: toStringOr(rawEvent.title, "In Progress"),
          description: toStringOr(rawEvent.description, ""),
          status: "active",
          startedAt: timestamp2,
          spotlight: toOptionalString(rawEvent.spotlight)
        }
      ];
      return {
        ...state,
        phases: sortPhases(next)
      };
    }
    case "codex-phase-complete": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      return {
        ...state,
        phases: sortPhases(
          state.phases.map(
            (phase) => phase.id === phaseId ? {
              ...phase,
              title: toOptionalString(rawEvent.title) ?? phase.title,
              description: toOptionalString(rawEvent.description) ?? phase.description,
              status: "completed",
              completedAt: timestamp2,
              spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight
            } : phase
          )
        )
      };
    }
    case "codex-phase-blocked": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId) return state;
      return {
        ...state,
        phases: state.phases.map(
          (phase) => phase.id === phaseId ? {
            ...phase,
            status: "blocked",
            spotlight: toOptionalString(rawEvent.reason) ?? toOptionalString(rawEvent.spotlight) ?? phase.spotlight
          } : phase
        )
      };
    }
    case "codex-phase-spotlight": {
      const phaseId = rawEvent.phaseId;
      if (!phaseId || !rawEvent.spotlight) return state;
      return {
        ...state,
        phases: state.phases.map(
          (phase) => phase.id === phaseId ? { ...phase, spotlight: toOptionalString(rawEvent.spotlight) ?? phase.spotlight } : phase
        )
      };
    }
    case "codex-template-decision": {
      return {
        ...state,
        templateDecision: {
          templateId: toStringOr(rawEvent.templateId, "unknown-template"),
          templateName: toOptionalString(rawEvent.templateName) ?? toOptionalString(rawEvent.displayName) ?? "Selected Template",
          repository: toOptionalString(rawEvent.repository),
          branch: toOptionalString(rawEvent.branch),
          confidence: typeof rawEvent.confidence === "number" ? rawEvent.confidence : void 0,
          rationale: toOptionalString(rawEvent.rationale) ?? toOptionalString(rawEvent.reason),
          decidedAt: timestamp2
        }
      };
    }
    case "codex-workspace-verified": {
      return {
        ...state,
        workspaceVerification: {
          directory: toOptionalString(rawEvent.directory) ?? toOptionalString(rawEvent.path) ?? "",
          exists: rawEvent.exists !== void 0 ? Boolean(rawEvent.exists) : true,
          discoveredEntries: toOptionalStringArray(rawEvent.entries),
          notes: toOptionalString(rawEvent.notes) ?? toOptionalString(rawEvent.summary),
          verifiedAt: timestamp2
        }
      };
    }
    case "codex-task-summary": {
      const bullets = Array.isArray(rawEvent.bullets) ? toOptionalStringArray(rawEvent.bullets) ?? [] : typeof rawEvent.summary === "string" ? rawEvent.summary.split("\n").map((line) => line.trim()).filter(Boolean) : [];
      return {
        ...state,
        taskSummary: {
          headline: toOptionalString(rawEvent.headline) ?? toOptionalString(rawEvent.title) ?? "Key Tasks Identified",
          bullets,
          capturedAt: timestamp2
        }
      };
    }
    case "codex-execution-insight": {
      const text2 = rawEvent.text ?? rawEvent.message ?? "";
      if (!text2) return state;
      const tone = ["success", "warning", "error", "info"].includes(
        toStringOr(rawEvent.tone, "")
      ) ? rawEvent.tone : "info";
      const insight = {
        id: toOptionalString(rawEvent.id) ?? `insight-${Date.now()}`,
        text: toStringOr(text2, ""),
        tone,
        timestamp: timestamp2
      };
      const existing = state.executionInsights ?? [];
      const existingIndex = existing.findIndex((item) => item.id === insight.id);
      const nextInsights = existingIndex >= 0 ? existing.map((item) => item.id === insight.id ? insight : item) : [...existing.slice(-19), insight];
      return {
        ...state,
        executionInsights: nextInsights
      };
    }
    default:
      return state;
  }
}
var CODEX_PHASE_ORDER;
var init_events = __esm({
  "src/lib/agents/codex/events.ts"() {
    CODEX_PHASE_ORDER = [
      "prompt-analysis",
      "template-selection",
      "template-clone",
      "workspace-verification",
      "task-synthesis",
      "execution"
    ];
  }
});

// src/lib/templates/config.server.ts
var config_server_exports = {};
__export(config_server_exports, {
  getAllTemplates: () => getAllTemplates,
  getTemplateById: () => getTemplateById,
  getTemplateSelectionContext: () => getTemplateSelectionContext,
  loadTemplateConfig: () => loadTemplateConfig,
  selectTemplateFromPrompt: () => selectTemplateFromPrompt,
  setTemplatesPath: () => setTemplatesPath
});
import { readFile } from "fs/promises";
import { join } from "path";
function setTemplatesPath(path) {
  configuredPath = path;
  process.env.TEMPLATES_JSON_PATH = path;
  cachedConfig = null;
}
function getTemplatesPath() {
  const path = configuredPath ?? process.env.TEMPLATES_JSON_PATH ?? join(process.cwd(), "templates.json");
  if (process.env.DEBUG_TEMPLATES === "1") {
    console.log("[templates] getTemplatesPath called:");
    console.log(`  configuredPath: ${configuredPath}`);
    console.log(`  env.TEMPLATES_JSON_PATH: ${process.env.TEMPLATES_JSON_PATH}`);
    console.log(`  resolved path: ${path}`);
  }
  return path;
}
async function loadTemplateConfig() {
  if (cachedConfig) {
    return cachedConfig;
  }
  const configPath = getTemplatesPath();
  const content = await readFile(configPath, "utf-8");
  cachedConfig = JSON.parse(content);
  console.log(`\u2705 Loaded ${cachedConfig.templates.length} templates from ${configPath}`);
  return cachedConfig;
}
async function getTemplateById(id) {
  const config = await loadTemplateConfig();
  return config.templates.find((t) => t.id === id) ?? null;
}
async function getAllTemplates() {
  const config = await loadTemplateConfig();
  return config.templates;
}
async function getTemplateSelectionContext() {
  const templates = await getAllTemplates();
  let context = "\u{1F3AF} AVAILABLE TEMPLATES:\n\n";
  for (const template of templates) {
    context += `**${template.name}** (ID: ${template.id})
`;
    context += `${template.description}

`;
    context += `\u{1F4E6} Clone command:
`;
    context += `  npx degit ${template.repository}#${template.branch} "<project-name>"

`;
    context += `Best for:
${template.selection.useCases.map((uc) => `  \u2022 ${uc}`).join("\n")}

`;
    context += `Example user requests:
${template.selection.examples.map((ex) => `  \u2022 "${ex}"`).join("\n")}

`;
    context += `Tech Stack: ${template.tech.framework} ${template.tech.version}, ${template.tech.language}, ${template.tech.styling}`;
    if (template.tech.uiLibrary) {
      context += `, ${template.tech.uiLibrary}`;
    }
    context += "\n\n";
    context += "---\n\n";
  }
  return context;
}
async function selectTemplateFromPrompt(userPrompt) {
  const templates = await getAllTemplates();
  const prompt = userPrompt.toLowerCase();
  const scores = templates.map((template) => {
    const keywords = template.selection.keywords;
    const matches = keywords.filter(
      (keyword) => prompt.includes(keyword.toLowerCase())
    );
    return {
      template,
      score: matches.length,
      matchedKeywords: matches
    };
  });
  scores.sort((a, b) => b.score - a.score);
  if (scores[0].score > 0) {
    console.log(`\u{1F3AF} Auto-selected template: ${scores[0].template.name}`);
    console.log(`   Matched keywords: ${scores[0].matchedKeywords.join(", ")}`);
    return scores[0].template;
  }
  console.log(`\u{1F3AF} No keyword matches, defaulting to react-vite (basic template)`);
  return templates.find((t) => t.id === "react-vite") ?? templates[0];
}
var cachedConfig, configuredPath;
var init_config_server = __esm({
  "src/lib/templates/config.server.ts"() {
    cachedConfig = null;
  }
});

// src/lib/templates/load-template-context.server.ts
var load_template_context_server_exports = {};
__export(load_template_context_server_exports, {
  loadTemplateSelectionContext: () => loadTemplateSelectionContext
});
async function loadTemplateSelectionContext(context) {
  if (context.templateSelectionContext) {
    return context.templateSelectionContext;
  }
  if (typeof window !== "undefined") {
    return void 0;
  }
  const { getTemplateSelectionContext: getTemplateSelectionContext2 } = await Promise.resolve().then(() => (init_config_server(), config_server_exports));
  return getTemplateSelectionContext2();
}
var init_load_template_context_server = __esm({
  "src/lib/templates/load-template-context.server.ts"() {
  }
});

// src/lib/templates/load-template-context.ts
async function loadTemplateSelectionContext2(context) {
  if (context.templateSelectionContext) {
    return context.templateSelectionContext;
  }
  if (typeof window !== "undefined") {
    return void 0;
  }
  const loader = await Promise.resolve().then(() => (init_load_template_context_server(), load_template_context_server_exports));
  return loader.loadTemplateSelectionContext(context);
}
var init_load_template_context = __esm({
  "src/lib/templates/load-template-context.ts"() {
  }
});

// src/lib/agents/codex-strategy.ts
var codex_strategy_exports = {};
__export(codex_strategy_exports, {
  default: () => codex_strategy_default
});
function getParentDirectory(filePath) {
  if (!filePath) return filePath;
  const normalized = filePath.replace(/\\/g, "/");
  const trimmed = normalized.replace(/\/+$|\/+$|\/*$/, "");
  const lastSlash = trimmed.lastIndexOf("/");
  if (lastSlash <= 0) {
    return "/";
  }
  return trimmed.slice(0, lastSlash);
}
function buildCodexSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  }
  if (context.isNewProject) {
    if (context.templateMetadata) {
      sections.push(`## Template Already Selected

- Template: ${context.templateName ?? "Selected template"}
- Repository: ${context.templateMetadata.repository}#${context.templateMetadata.branch}
- The template has been chosen based on your analysis of the user's request
- Clone command: npx degit ${context.templateMetadata.repository}#${context.templateMetadata.branch} ${context.projectName}
- CRITICAL: After cloning, prefix EVERY bash command with "cd ${context.projectName} &&"
- Follow the setup instructions exactly before implementing the request`);
    } else {
      sections.push(`## Template Selection and Setup

- Codex selects the appropriate template using the provided catalog
- After cloning, prefix EVERY bash command with "cd ${context.projectName} &&"
- Remember: bash commands run in fresh shells - cd does not persist
- Follow the setup instructions exactly before implementing the request`);
    }
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Modify the existing codebase to satisfy the request.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      existingProjectSection += `You have access to recent conversation history. Use this to understand context:

`;
      context.conversationHistory.forEach((msg, index2) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const timestamp2 = msg.timestamp instanceof Date ? msg.timestamp.toISOString() : msg.timestamp;
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index2 + 1}. ${roleLabel} (${timestamp2}):
${content}

`;
      });
      existingProjectSection += `Use this history to understand:
- What has been built or discussed
- User preferences and requirements
- References to "it", "the app", "the project"
- Previous decisions or implementations

Apply the current request in context of this conversation.`;
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- ${context.isNewProject ? `After cloning, prefix ALL bash commands with "cd ${context.projectName} &&"` : "Operate inside the workspace directory"}
- Each bash command runs in a fresh shell - cd does not persist between commands
- ${context.isNewProject ? `Example: bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'` : "Use relative paths for file operations"}
- Provide complete file contents for every modification`);
  sections.push(`## Task Tracking - Internal System (NOT A TOOL)

IMPORTANT: Task tracking is done by including JSON in your text responses.
This is NOT a tool to call, NOT a command to run, NOT something to install.

Simply include a JSON code block in your response like this:

\`\`\`json
{"todos":[
  {"content":"Clone template","status":"completed","activeForm":"Cloned template"},
  {"content":"Implement features","status":"in_progress","activeForm":"Implementing features"},
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"}
]}
\`\`\`

The system automatically extracts this from your response text.
DO NOT try to call it as a tool, run it as a command, or install it as a binary.
Just include the JSON code block in your message.`);
  if (context.templateSelectionContext && !context.templateMetadata) {
    sections.push(buildCodexTemplateCatalogSection(context.templateSelectionContext));
  }
  return sections;
}
function buildFullPrompt2(context, basePrompt) {
  if (!context.isNewProject) {
    return basePrompt;
  }
  if (context.templateMetadata) {
    const { repository, branch } = context.templateMetadata;
    return `USER REQUEST: ${basePrompt}

WORKFLOW INSTRUCTIONS:

You will complete this request in ONE continuous session by following these exact steps:

STEP 1: CREATE TASK BREAKDOWN
First, analyze the request and determine what specific tasks need to be done.

Create AS MANY TASKS AS NEEDED to properly build the MVP. This could be:
- Simple request: 3-4 tasks
- Medium request: 5-8 tasks
- Complex request: 10-15+ tasks

Think through ALL the work required.

Then include a JSON code block in your response:
\`\`\`json
{"todos":[
  {"content":"Clone and configure template","status":"in_progress","activeForm":"Cloning and configuring template"},
  {"content":"Implement features","status":"pending","activeForm":"Implementing features"},
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"},
  ...as many as needed...
  {"content":"Verify build","status":"pending","activeForm":"Verifying build"}
]}
\`\`\`

The system will automatically extract this. Do NOT try to call it as a tool or command.

STEP 2: CLONE AND CONFIGURE
   bash -lc 'npx degit ${repository}#${branch} ${context.projectName}'
   bash -lc 'ls ${context.projectName}'
   bash -lc 'cd ${context.projectName} && cat > .npmrc << EOF
save-exact=true
legacy-peer-deps=false
engine-strict=true
EOF'
   bash -lc 'cd ${context.projectName} && npm pkg set name="${context.projectName}"'

After setup, include updated JSON code block (mark setup as "completed")

STEP 3: IMPLEMENT ALL FEATURES AND DEPENDENCY CHANGES
   - Modify template files to deliver the requested functionality
   - Use: bash -lc 'cd ${context.projectName} && cat > filepath << EOF
...
EOF'
   - Implement EVERY requested feature completely
   - Finish all package.json dependency changes before installing
   - After each major feature, include updated JSON code block

STEP 4: INSTALL DEPENDENCIES ONCE
   bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'

After installing, include updated JSON code block

STEP 5: VERIFY BUILD
   bash -lc 'cd ${context.projectName} && npm run build'

After successful build, include final JSON code block with all tasks "completed"

CRITICAL: You MUST complete ALL 5 steps in this single session.
Each bash command runs in a fresh shell - prefix with "cd ${context.projectName} &&"
Only respond "Implementation complete" after ALL steps are verified.`;
  }
  return `USER REQUEST: ${basePrompt}

WORKFLOW INSTRUCTIONS:

You will complete this request in ONE continuous session by following these exact steps:

STEP 1: CREATE TASK BREAKDOWN
First, analyze the request and determine what tasks are needed.

Create AS MANY TASKS AS NEEDED to properly build the MVP. This could be:
- Simple request: 3-4 tasks
- Medium request: 5-8 tasks
- Complex request: 10-15+ tasks

Think through ALL the work required.

Then include a JSON code block in your response:
\`\`\`json
{"todos":[
  {"content":"Select and clone template","status":"in_progress","activeForm":"Selecting and cloning template"},
  ...as many tasks as needed...
  {"content":"Install dependencies once","status":"pending","activeForm":"Installing dependencies"},
  {"content":"Verify build","status":"pending","activeForm":"Verifying build"}
]}
\`\`\`

The system automatically extracts this. Do NOT try to call it as a tool or command.

STEP 2: CLONE AND CONFIGURE
   Choose appropriate template from available options
   bash -lc 'npx degit <repository>#<branch> ${context.projectName}'
   bash -lc 'ls ${context.projectName}'
   bash -lc 'cd ${context.projectName} && cat > .npmrc << EOF
save-exact=true
EOF'
   bash -lc 'cd ${context.projectName} && npm pkg set name="${context.projectName}"'

After setup, include updated JSON code block (mark setup as "completed")

STEP 3: IMPLEMENT ALL FEATURES AND DEPENDENCY CHANGES
   - Modify template files to deliver requested functionality
   - ALL commands: bash -lc 'cd ${context.projectName} && ...'
   - Implement EVERY requested feature completely
   - Finish all package.json dependency changes before installing
   - After each major feature, include updated JSON code block

STEP 4: INSTALL DEPENDENCIES ONCE
   bash -lc 'cd ${context.projectName} && npm install --prefer-offline --no-audit --no-fund'

After installing, include updated JSON code block

STEP 5: VERIFY BUILD
   bash -lc 'cd ${context.projectName} && npm run build'

After successful build, include final JSON code block with all tasks "completed"

CRITICAL: Complete ALL 5 steps in this single session.
Each bash command runs in a fresh shell - prefix with "cd ${context.projectName} &&"
Only respond "Implementation complete" after ALL steps are verified.`;
}
var codexStrategy, codex_strategy_default;
var init_codex_strategy = __esm({
  "src/lib/agents/codex-strategy.ts"() {
    init_template_catalog();
    init_events();
    init_load_template_context();
    init_resolver();
    codexStrategy = {
      buildSystemPromptSections: buildCodexSections,
      buildFullPrompt: buildFullPrompt2,
      shouldDownloadTemplate() {
        return false;
      },
      resolveWorkingDirectory(context) {
        if (!context.isNewProject) {
          return context.workingDirectory;
        }
        return getParentDirectory(context.workingDirectory);
      },
      async getTemplateSelectionContext(context) {
        return loadTemplateSelectionContext2(context);
      },
      processRunnerEvent(state, event) {
        if (!state || typeof state !== "object") {
          return state;
        }
        const codexLike = state;
        if (!Array.isArray(codexLike?.phases)) {
          return state;
        }
        const next = processCodexEvent(codexLike, event);
        return next;
      }
    };
    codex_strategy_default = codexStrategy;
  }
});

// src/lib/agents/droid-strategy.ts
var droid_strategy_exports = {};
__export(droid_strategy_exports, {
  default: () => droid_strategy_default
});
function buildDroidSections(context) {
  const sections = [];
  if (context.tags && context.tags.length > 0) {
    const resolved = resolveTags(context.tags);
    const tagPrompt = generatePromptFromTags(resolved, context.projectName, context.isNewProject);
    if (tagPrompt) {
      sections.push(tagPrompt);
    }
  }
  if (context.isNewProject) {
    sections.push(`## New Project Setup

- Project name: ${context.projectName}
- Location: ${context.workingDirectory}
- Operation type: ${context.operationType}

The template has already been downloaded. Customize the scaffold to satisfy the request; follow the dependency-state instructions below for installation.`);
  } else {
    let existingProjectSection = `## Existing Project Context

- Project location: ${context.workingDirectory}
- Operation type: ${context.operationType}

Review the current codebase and apply the requested changes without re-scaffolding.`;
    if (context.conversationHistory && context.conversationHistory.length > 0) {
      existingProjectSection += `

**Recent Conversation History:**
`;
      context.conversationHistory.forEach((msg, index2) => {
        const roleLabel = msg.role === "user" ? "User" : "Assistant";
        const content = msg.content.length > 500 ? msg.content.substring(0, 500) + "...[truncated]" : msg.content;
        existingProjectSection += `${index2 + 1}. ${roleLabel}:
${content}

`;
      });
    }
    sections.push(existingProjectSection);
  }
  sections.push(`## Workspace Rules
- Use relative paths within the project.
- Work inside the existing project structure.
- Provide complete file contents without placeholders.`);
  if (context.fileTree) {
    sections.push(`## Project Manifest
${context.fileTree}`);
  }
  if (context.templateName) {
    sections.push(`## Template
- Name: ${context.templateName}
- Framework: ${context.templateFramework ?? "unknown"}`);
  }
  return sections;
}
function buildFullPrompt3(context, basePrompt) {
  if (!context.isNewProject) {
    return basePrompt;
  }
  return `${basePrompt}

CRITICAL: The template has already been prepared in ${context.workingDirectory}. Do not scaffold a new project.`;
}
var droidStrategy, droid_strategy_default;
var init_droid_strategy = __esm({
  "src/lib/agents/droid-strategy.ts"() {
    init_resolver();
    droidStrategy = {
      buildSystemPromptSections: buildDroidSections,
      buildFullPrompt: buildFullPrompt3,
      shouldDownloadTemplate(context) {
        return context.isNewProject && !context.skipTemplates;
      },
      postTemplateSelected(context, template) {
        context.templateName = template.name;
        context.templateFramework = template.framework;
        context.fileTree = template.fileTree;
      }
    };
    droid_strategy_default = droidStrategy;
  }
});

// src/lib/prompts.ts
var CLAUDE_SYSTEM_PROMPT = `You are an elite coding assistant specialized in building visually stunning, production-ready JavaScript applications.

## Build Workflow

- Begin project work immediately. Do not load skills or plugins, and do not enter plan mode unless the user explicitly asks for a plan.
- Read the relevant existing files before editing. Preserve working scaffold behavior and customize it instead of generating a replacement app.
- For multi-step work, track progress with the TodoWrite tool (\`content\`, \`activeForm\`, \`status\` of \`pending\`/\`in_progress\`/\`completed\`). Keep the list short (4-8 items), emit the complete list on every update, and keep exactly one item in progress until done. Do not call Task, Skill, or MCP tools.
- Use WebSearch/WebFetch only when you need external docs or API context you do not already have. Prefer local files and the project manifest first.
- Prefer Write/Edit over long exploratory Bash sessions.
- Inspect package files first, make all code and dependency-manifest changes, then install dependencies together once. For npm, prefer \`npm install --prefer-offline --no-audit --no-fund\`. Do not repeatedly install packages one at a time.
- For UI work, produce a coherent, responsive, accessible design with intentional typography, spacing, hierarchy, and interaction states. Avoid generic placeholder styling and unnecessary rewrites.
- Run the project's build or typecheck after implementation. Fix errors and rerun until clean. Only start a dev server once, at the end when runtime verification is useful, and stop it afterward.
- Stop as soon as the request is met and validation is clean. Do not keep polishing, researching alternatives, or adding unrequested scope.
- Work quietly between progress updates. Finish with a concise summary of what changed and what validation passed.

## Plan Mode

If you use ExitPlanMode to submit a plan, the system will automatically approve it.
When you receive plan approval, IMMEDIATELY begin implementing - do not summarize or stop.

## Continuation

If your response was cut off mid-stream:
- Resume from the EXACT point of interruption
- Do NOT repeat completed work or re-explain context
- Continue the current task, don't restart
`;
var CODEX_SYSTEM_PROMPT = `You are an elite coding assistant specialized in building visually stunning, production-ready JavaScript applications.

## Plan Mode

If you submit a plan, the system will automatically approve it.
When you receive plan approval, IMMEDIATELY begin implementing - do not summarize or stop.

## Continuation

If your response was cut off mid-stream:
- Resume from the EXACT point of interruption
- Do NOT repeat completed work or re-explain context
- Continue the current task, don't restart
`;

// src/shared/runner/messages.ts
var COMMAND_TYPES = [
  "analyze-project",
  "start-build",
  "cancel-build",
  "start-dev-server",
  "stop-dev-server",
  "fetch-logs",
  "runner-health-check",
  "delete-project-files",
  "read-file",
  "write-file",
  "list-files",
  "http-proxy-request",
  "hmr-connect",
  "hmr-message",
  "hmr-disconnect",
  "github-sync",
  "github-push"
];
var isRunnerCommand = (message) => COMMAND_TYPES.includes(message.type);
var isRunnerEvent = (message) => !isRunnerCommand(message);

// src/types/agent.ts
var DEFAULT_AGENT_ID = "claude-code";
var DEFAULT_CLAUDE_MODEL_ID = "claude-sonnet-5";
var DEFAULT_OPENCODE_MODEL_ID = "anthropic/claude-sonnet-5";
var LEGACY_MODEL_MAP = {
  "claude-haiku-4-5": "anthropic/claude-haiku-4-5",
  "claude-sonnet-5": "anthropic/claude-sonnet-5",
  "claude-opus-4-8": "anthropic/claude-opus-4-8",
  // Upgrade previously-saved Sonnet 4.6 selections to Sonnet 5
  "claude-sonnet-4-6": "anthropic/claude-sonnet-5",
  // Legacy aliases — upgrade previously-saved selections to the current model
  "claude-opus-4-6": "anthropic/claude-opus-4-8",
  "claude-opus-4-6-20251101": "anthropic/claude-opus-4-8",
  "gpt-5-codex": "openai/gpt-5.2-codex",
  "gpt-5.2-codex": "openai/gpt-5.2-codex"
};
function normalizeModelId(modelId) {
  if (modelId.includes("/")) {
    return modelId;
  }
  return LEGACY_MODEL_MAP[modelId] || `anthropic/${modelId}`;
}
function parseModelId(modelId) {
  const normalized = normalizeModelId(modelId);
  const [provider, ...modelParts] = normalized.split("/");
  return {
    provider: provider || "anthropic",
    model: modelParts.join("/") || "claude-sonnet-5"
  };
}
var CLAUDE_MODEL_METADATA = {
  "claude-haiku-4-5": {
    label: "Claude Haiku 4.5",
    description: "Fast and efficient Claude model",
    provider: "anthropic"
  },
  "claude-sonnet-5": {
    label: "Claude Sonnet 5",
    description: "Best balance of speed and intelligence",
    provider: "anthropic"
  },
  "claude-opus-4-8": {
    label: "Claude Opus 4.8",
    description: "Most capable Claude model for complex tasks",
    provider: "anthropic"
  }
};
var MODEL_METADATA = {
  "anthropic/claude-haiku-4-5": {
    label: "Claude Haiku 4.5",
    description: "Fast and efficient",
    provider: "anthropic"
  },
  "anthropic/claude-sonnet-5": {
    label: "Claude Sonnet 5",
    description: "Best balance of speed and intelligence",
    provider: "anthropic"
  },
  "anthropic/claude-opus-4-8": {
    label: "Claude Opus 4.8",
    description: "Most capable for complex tasks",
    provider: "anthropic"
  },
  "openai/gpt-4o": {
    label: "GPT-4o",
    description: "OpenAI flagship model",
    provider: "openai"
  },
  "openai/o3": {
    label: "o3",
    description: "OpenAI reasoning model",
    provider: "openai"
  },
  "google/gemini-2.5-pro": {
    label: "Gemini 2.5 Pro",
    description: "Google flagship model",
    provider: "google"
  },
  "deepseek/deepseek-chat": {
    label: "DeepSeek Chat",
    description: "DeepSeek conversational model",
    provider: "deepseek"
  },
  "deepseek/deepseek-reasoner": {
    label: "DeepSeek Reasoner",
    description: "DeepSeek reasoning model",
    provider: "deepseek"
  },
  "openai/gpt-5.2-codex": {
    label: "GPT-5.2 Codex",
    description: "OpenAI Codex - Advanced code generation",
    provider: "openai"
  }
};
function getModelLabel(modelId) {
  const normalized = normalizeModelId(modelId);
  return MODEL_METADATA[normalized]?.label ?? CLAUDE_MODEL_METADATA[modelId]?.label ?? modelId;
}

// src/types/github.ts
var GITHUB_CHAT_MESSAGES = {
  /** Push code to an existing repository (repo URL will be in context) */
  PUSH_CODE: "Push code to GitHub repository using the github-setup skill.",
  /** Sync changes to existing repository */
  SYNC: "Stage all current changes, commit, and push to the remote repository.",
  /** Legacy - kept for backwards compatibility */
  SETUP: "Set up GitHub repository for this project. Create a new public repository and push the code.",
  PUSH: "Push the latest changes to GitHub.",
  CHECK_AUTH: "Check if GitHub CLI is authenticated."
};

// src/types/neondb.ts
var NEONDB_CHAT_MESSAGES = {
  SETUP: "Configure a NeonDB PostgreSQL database for this project."
};

// src/lib/agents/strategy.ts
var strategyRegistry = /* @__PURE__ */ new Map();
function registerAgentStrategy(agentId, strategy) {
  strategyRegistry.set(agentId, strategy);
}
function getAgentStrategy(agentId) {
  const strategy = strategyRegistry.get(agentId);
  if (!strategy) {
    throw new Error(`No strategy registered for agent: ${agentId}`);
  }
  return strategy;
}

// src/lib/agents/index.ts
var initialized = false;
async function ensureRegistry() {
  if (initialized) {
    return;
  }
  const [
    { default: claudeStrategy2 },
    { default: codexStrategy2 },
    { default: droidStrategy2 }
  ] = await Promise.all([
    Promise.resolve().then(() => (init_claude_strategy(), claude_strategy_exports)),
    Promise.resolve().then(() => (init_codex_strategy(), codex_strategy_exports)),
    Promise.resolve().then(() => (init_droid_strategy(), droid_strategy_exports))
  ]);
  registerAgentStrategy("claude-code", claudeStrategy2);
  registerAgentStrategy("openai-codex", codexStrategy2);
  registerAgentStrategy("factory-droid", droidStrategy2);
  initialized = true;
}
async function resolveAgentStrategy(agentId) {
  await ensureRegistry();
  return getAgentStrategy(agentId);
}

// src/index.ts
init_config_server();

// src/lib/logging/build-logger.ts
var BuildLogger = class {
  buildId = null;
  projectId = null;
  /**
   * Set correlation IDs for the current build
   * Call this at the start of each build to enable correlation tracking
   */
  setBuildContext(buildId, projectId) {
    this.buildId = buildId;
    this.projectId = projectId;
    this.log("debug", "runner", `Build context set: ${buildId} / ${projectId}`);
  }
  /**
   * Clear correlation IDs after build completes
   */
  clearBuildContext() {
    this.log("debug", "runner", "Build context cleared");
    this.buildId = null;
    this.projectId = null;
  }
  /**
   * Core logging method - creates structured log entries
   * Public for custom logging needs
   */
  log(level, context, message, data) {
    if (process.env.SILENT_MODE === "1") {
      return;
    }
    if (level === "info" || level === "debug") {
      if (process.env.DEBUG_BUILD === "0") {
        return;
      }
    }
    const entry = {
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      level,
      context,
      buildId: this.buildId ?? void 0,
      projectId: this.projectId ?? void 0,
      message,
      data
    };
    const prefix = `[${context}]`;
    const icon = {
      debug: "\u{1F50D}",
      info: "\u{1F4CB}",
      warn: "\u26A0\uFE0F ",
      error: "\u274C"
    }[level];
    const logFn = level === "error" ? console.error : level === "warn" ? console.warn : console.log;
    if (data && Object.keys(data).length > 0) {
      logFn(`${icon} ${prefix} ${message}`, data);
    } else {
      logFn(`${icon} ${prefix} ${message}`);
    }
  }
  /**
   * Orchestrator-specific logging methods
   */
  orchestrator = {
    newProject: (operationType) => this.log("info", "orchestrator", `NEW PROJECT (operationType: ${operationType})`),
    existingProject: (operationType) => this.log("info", "orchestrator", `EXISTING PROJECT (operationType: ${operationType})`),
    templateProvided: (templateName, templateId, framework) => this.log("info", "orchestrator", `Frontend provided template: ${templateName}`, {
      templateId,
      framework
    }),
    templateSelecting: (method) => this.log("info", "orchestrator", `Template selection: ${method}`),
    templateSelected: (templateName, templateId) => this.log("info", "orchestrator", `Selected template: ${templateName}`, { templateId }),
    templateDownloading: (templateName, repository, target) => this.log("info", "orchestrator", `Downloading template: ${templateName}`, {
      repository,
      target
    }),
    templateDownloaded: (templateName, path, fileTreeSize) => this.log("info", "orchestrator", `Template downloaded: ${templateName}`, {
      path,
      fileTreeSize
    }),
    catalogPrepared: (catalogSize) => this.log("info", "orchestrator", `Template catalog prepared (${catalogSize} chars)`, {
      catalogSize
    }),
    systemPromptGenerated: (size) => this.log("info", "orchestrator", `System prompt generated (${size} chars)`, { size }),
    orchestrationComplete: (data) => this.log("info", "orchestrator", "Orchestration complete", data),
    error: (message, error) => this.log("error", "orchestrator", message, {
      error: error instanceof Error ? error.message : String(error)
    })
  };
  /**
   * Message transformer-specific logging methods
   */
  transformer = {
    todoListFound: () => this.log("debug", "transformer", "Found Codex task list, parsing..."),
    todoListParsed: (todoCount, completed, inProgress, pending) => this.log("info", "transformer", `Parsed ${todoCount} todos`, {
      completed,
      inProgress,
      pending
    }),
    todoListInvalidFormat: (expected, got) => this.log("error", "transformer", "Invalid todo format from Codex", {
      expected,
      got: JSON.stringify(got).substring(0, 200)
    }),
    todoListParseError: (error, rawJson) => this.log("error", "transformer", "Failed to parse Codex todolist", {
      error: String(error),
      rawJson: rawJson.substring(0, 300)
    }),
    todoListRemoved: () => this.log("debug", "transformer", "Removed task list from chat text"),
    toolStarted: (toolName, toolId) => this.log("debug", "transformer", `Tool started: ${toolName}`, { toolName, toolId }),
    toolCompleted: (toolName, toolId) => this.log("debug", "transformer", `Tool completed: ${toolName}`, { toolName, toolId }),
    pathViolationWarning: (toolName, path, workspace) => this.log("warn", "transformer", `Path outside workspace: ${path}`, {
      toolName,
      path,
      workspace
    }),
    desktopPathDetected: (path) => this.log("error", "transformer", `DESKTOP PATH DETECTED - Likely hallucinated: ${path}`, { path })
  };
  /**
   * Codex query-specific logging methods
   */
  codexQuery = {
    promptBuilding: (workingDirectory, systemPromptSize, userPromptSize) => this.log("info", "codex-query", "Building Codex prompt", {
      workingDirectory,
      systemPromptSize,
      userPromptSize
    }),
    threadStarting: () => this.log("info", "codex-query", "Starting Codex thread (multi-turn)"),
    turnStarted: (turnNumber, maxTurns, promptSize) => this.log("info", "codex-query", `\u2550\u2550\u2550 Turn ${turnNumber}/${maxTurns} \u2550\u2550\u2550`, {
      turnNumber,
      maxTurns,
      promptSize
    }),
    taskListExtracted: () => this.log("info", "codex-query", "Task list extracted and updated"),
    taskListStatus: (completed, inProgress, pending, total) => this.log("info", "codex-query", `Tasks: ${completed} completed | ${inProgress} in_progress | ${pending} pending (total: ${total})`, {
      completed,
      inProgress,
      pending,
      total
    }),
    taskListTask: (index2, content, status, icon) => this.log("debug", "codex-query", `  ${icon} ${index2 + 1}. ${content}`, { status }),
    taskListParseError: (error, rawContent) => this.log("error", "codex-query", "PARSE ERROR: Could not parse task list JSON", {
      error: String(error),
      rawContent: rawContent.substring(0, 200)
    }),
    taskListMissing: (turnNumber) => this.log("warn", "codex-query", `WARNING: No <start-todolist> tags found in Turn ${turnNumber}`, {
      turnNumber
    }),
    turnComplete: (turnNumber, hadToolCalls, messageLength) => this.log("info", "codex-query", `Turn ${turnNumber} complete`, {
      hadToolCalls,
      messageLength
    }),
    tasksComplete: (completed, total) => this.log("info", "codex-query", `Task status: ${completed}/${total} completed`, {
      completed,
      total
    }),
    allComplete: () => this.log("info", "codex-query", "\u2705 All MVP tasks complete!"),
    allTasksComplete: () => this.log("info", "codex-query", "\u2705 All MVP tasks complete!"),
    taskCompleteDetected: () => this.log("info", "codex-query", "\u2705 Task complete (detected completion signal)"),
    continuePrompting: (reason) => this.log("warn", "codex-query", `No tools used but not done - ${reason}`),
    continuing: () => this.log("info", "codex-query", "\u23ED\uFE0F  Continuing to next turn (had tool calls)"),
    loopExited: (turnCount, maxTurns) => this.log("info", "codex-query", `EXITED WHILE LOOP after ${turnCount} turns`, {
      turnCount,
      maxTurns
    }),
    sessionComplete: (turnCount) => this.log("info", "codex-query", `Session complete after ${turnCount} turns`, { turnCount }),
    error: (message, error) => this.log("error", "codex-query", message, {
      error: error instanceof Error ? error.message : String(error)
    })
  };
  /**
   * Claude query-specific logging methods
   */
  claudeQuery = {
    queryStarted: (model, cwd, maxTurns) => this.log("info", "claude-query", `Starting Claude query (${model})`, {
      cwd,
      maxTurns
    }),
    error: (message, error) => this.log("error", "claude-query", message, {
      error: error instanceof Error ? error.message : String(error)
    })
  };
  /**
   * Runner-specific logging methods
   */
  runner = {
    workspaceRoot: (path) => this.log("info", "runner", `Workspace root: ${path}`, { path }),
    commandReceived: (commandType, projectId) => this.log("info", "runner", `Received command: ${commandType}`, { commandType, projectId }),
    buildOperation: (operationType, projectSlug, agentId) => this.log("info", "runner", `Build operation: ${operationType}`, {
      operationType,
      projectSlug,
      agentId
    }),
    templateProvided: (templateId) => this.log("info", "runner", `Template provided by frontend: ${templateId}`, { templateId }),
    buildStreamCreated: () => this.log("info", "runner", "Build stream created, starting to process chunks..."),
    firstChunkReceived: (agentLabel) => this.log("info", "runner", `First chunk received from ${agentLabel}`, { agentLabel }),
    streamEnded: (chunkCount) => this.log("info", "runner", `Stream ended after ${chunkCount} chunks`, { chunkCount }),
    buildCompleted: (projectId) => this.log("info", "runner", `Build completed successfully`, { projectId }),
    buildFailed: (error) => this.log("error", "runner", `Build failed: ${error}`, { error }),
    portDetected: (port) => this.log("info", "runner", `Port detected: ${port}`, { port }),
    tunnelCreated: (port, tunnelUrl) => this.log("info", "runner", `Tunnel created: ${tunnelUrl} \u2192 localhost:${port}`, {
      port,
      tunnelUrl
    }),
    error: (message, error, context) => this.log("error", "runner", message, {
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : void 0,
      ...context
    })
  };
  /**
   * Build stream-specific logging (tool calls, text, etc.)
   */
  build = {
    agentText: (agentLabel, text2) => {
      const truncated = text2.length > 200 ? text2.slice(0, 200) + "..." : text2;
      this.log("debug", "build", `${agentLabel}: ${truncated}`, {
        agentLabel,
        textLength: text2.length
      });
    },
    agentThinking: (thinking) => {
      const truncated = thinking.length > 300 ? thinking.slice(0, 300) + "..." : thinking;
      this.log("debug", "build", `Thinking: ${truncated}`, {
        thinkingLength: thinking.length
      });
    },
    toolCalled: (toolName, toolId, inputSize) => this.log("info", "build", `Tool called: ${toolName} (${toolId})`, {
      toolName,
      toolId,
      inputSize
    }),
    toolResult: (toolId, outputSize, isError) => this.log(isError ? "error" : "info", "build", `Tool result (${toolId})`, {
      toolId,
      outputSize,
      isError
    }),
    runCommandDetected: (runCommand) => this.log("info", "build", `Detected runCommand: ${runCommand}`, { runCommand })
  };
  /**
   * WebSocket-specific logging methods
   */
  websocket = {
    serverCreated: (instanceId) => this.log("info", "websocket", `WebSocket server instance created`, { instanceId }),
    serverInitialized: (path, runnerPath) => this.log("info", "websocket", `Server initialized`, { path, runnerPath }),
    clientConnected: (clientId, projectId, sessionId) => this.log("info", "websocket", `Client connected: ${clientId}`, { clientId, projectId, sessionId }),
    clientDisconnected: (clientId) => this.log("info", "websocket", `Client disconnected: ${clientId}`, { clientId }),
    clientSubscribed: (clientId, projectId) => this.log("info", "websocket", `Client subscribed to project: ${projectId}`, { clientId, projectId }),
    clientTimeout: (clientId) => this.log("warn", "websocket", `Client timeout: ${clientId}`, { clientId }),
    runnerConnected: (runnerId) => this.log("info", "websocket", `Runner connected: ${runnerId}`, { runnerId }),
    runnerDisconnected: (runnerId, code) => this.log("info", "websocket", `Runner disconnected: ${runnerId}`, { runnerId, code }),
    runnerNotConnected: (runnerId, commandType) => this.log("warn", "websocket", `Cannot send command to runner ${runnerId}: not connected`, {
      runnerId,
      commandType
    }),
    runnerAuthRejected: () => this.log("warn", "websocket", `Runner connection rejected: invalid auth`),
    runnerAuthMissing: () => this.log("error", "websocket", `RUNNER_SHARED_SECRET is not configured`),
    runnerStaleRemoved: (runnerId) => this.log("info", "websocket", `Removing stale runner connection: ${runnerId}`, { runnerId }),
    commandSent: (runnerId, commandType, traceAttached) => this.log("debug", "websocket", `Sent command to runner: ${commandType}`, {
      runnerId,
      commandType,
      traceAttached
    }),
    eventReceived: (runnerId, eventType) => this.log("debug", "websocket", `Received event from runner: ${eventType}`, {
      runnerId,
      eventType
    }),
    broadcastToolCall: (toolName, toolState, subscriberCount) => this.log("info", "websocket", `Broadcasting planning tool: ${toolName} (state=${toolState})`, {
      toolName,
      toolState,
      subscriberCount
    }),
    broadcastBuildComplete: (projectId, sessionId, subscriberCount) => this.log("info", "websocket", `Broadcasting build-complete`, {
      projectId,
      sessionId,
      subscriberCount
    }),
    unknownUpgradePath: (pathname) => this.log("warn", "websocket", `Unknown upgrade path: ${pathname}`, { pathname }),
    shutdown: () => this.log("info", "websocket", `Shutting down server...`),
    shutdownComplete: () => this.log("info", "websocket", `Server shut down`),
    error: (message, error, context) => this.log("error", "websocket", message, {
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : void 0,
      ...context
    })
  };
  /**
   * Port allocator-specific logging methods
   */
  portAllocator = {
    portAllocated: (port, projectId) => this.log("info", "port-allocator", `Port allocated: ${port}`, { port, projectId }),
    portReleased: (port, projectId) => this.log("info", "port-allocator", `Port released: ${port}`, { port, projectId }),
    portInUse: (port) => this.log("warn", "port-allocator", `Port ${port} is already in use`, { port }),
    portRangeExhausted: (minPort, maxPort) => this.log("error", "port-allocator", `No available ports in range ${minPort}-${maxPort}`, {
      minPort,
      maxPort
    }),
    portConflict: (port, projectId, existingProjectId) => this.log("warn", "port-allocator", `Port ${port} conflict detected`, {
      port,
      projectId,
      existingProjectId
    }),
    allocationsCleared: (count) => this.log("info", "port-allocator", `Cleared ${count} port allocations`, { count }),
    error: (message, error, context) => this.log("error", "port-allocator", message, {
      error: error instanceof Error ? error.message : String(error),
      ...context
    })
  };
  /**
   * Process manager-specific logging methods
   */
  processManager = {
    processStarting: (projectId, command, cwd) => this.log("info", "process-manager", `Starting process: ${command}`, {
      projectId,
      command,
      cwd
    }),
    processStarted: (projectId, pid) => this.log("info", "process-manager", `Process started`, { projectId, pid }),
    processOutput: (projectId, output) => this.log("debug", "process-manager", `Process output: ${output.substring(0, 100)}`, {
      projectId,
      outputLength: output.length
    }),
    processError: (projectId, error) => this.log("error", "process-manager", `Process error: ${error}`, { projectId, error }),
    processExited: (projectId, code, signal) => this.log("info", "process-manager", `Process exited`, { projectId, code, signal }),
    processStopped: (projectId) => this.log("info", "process-manager", `Process stopped`, { projectId }),
    processNotFound: (projectId) => this.log("warn", "process-manager", `Process not found for project: ${projectId}`, { projectId }),
    processKilled: (projectId, signal) => this.log("info", "process-manager", `Process killed with signal: ${signal}`, {
      projectId,
      signal
    }),
    processCleanup: (projectId) => this.log("info", "process-manager", `Cleaning up process`, { projectId }),
    processListRetrieved: (count) => this.log("debug", "process-manager", `Retrieved ${count} running processes`, { count }),
    error: (message, error, context) => this.log("error", "process-manager", message, {
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : void 0,
      ...context
    })
  };
  /**
   * Build events-specific logging methods
   */
  buildEvents = {
    eventReceived: (eventType, projectId, sessionId) => this.log("info", "build-events", `Received event: ${eventType}`, {
      eventType,
      projectId,
      sessionId
    }),
    eventProcessed: (eventType, projectId) => this.log("debug", "build-events", `Processed event: ${eventType}`, { eventType, projectId }),
    buildStarted: (projectId, sessionId) => this.log("info", "build-events", `Build started`, { projectId, sessionId }),
    buildCompleted: (projectId, sessionId, success) => this.log("info", "build-events", `Build ${success ? "completed" : "failed"}`, {
      projectId,
      sessionId,
      success
    }),
    portDetected: (projectId, port) => this.log("info", "build-events", `Port detected: ${port}`, { projectId, port }),
    devServerStarted: (projectId, port, url) => this.log("info", "build-events", `Dev server started: ${url}`, { projectId, port, url }),
    devServerError: (projectId, error) => this.log("error", "build-events", `Dev server error: ${error}`, { projectId, error }),
    toolCallReceived: (toolName, toolId) => this.log("debug", "build-events", `Tool call: ${toolName}`, { toolName, toolId }),
    logChunkReceived: (projectId, chunkSize) => this.log("debug", "build-events", `Log chunk received`, { projectId, chunkSize }),
    invalidEvent: (reason) => this.log("warn", "build-events", `Invalid event: ${reason}`, { reason }),
    error: (message, error, context) => this.log("error", "build-events", message, {
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : void 0,
      ...context
    })
  };
};
var buildLogger = new BuildLogger();

// src/lib/websocket/server.ts
import { WebSocketServer, WebSocket } from "ws";

// src/lib/runner/event-stream.ts
var subscribers = global.__runnerEventSubscribers ?? /* @__PURE__ */ new Map();
global.__runnerEventSubscribers = subscribers;
function publishRunnerEvent(event) {
  if (!event.commandId) {
    return;
  }
  const set = subscribers.get(event.commandId);
  if (!set) {
    return;
  }
  for (const handler of set) {
    handler(event);
  }
}

// src/lib/db/client.ts
import { drizzle } from "drizzle-orm/node-postgres";
import pg from "pg";

// src/lib/db/schema.ts
var schema_exports = {};
__export(schema_exports, {
  accounts: () => accounts,
  buildMetrics: () => buildMetrics,
  cliAuthSessions: () => cliAuthSessions,
  generationNotes: () => generationNotes,
  generationSessions: () => generationSessions,
  generationTodos: () => generationTodos,
  generationToolCalls: () => generationToolCalls,
  githubConnections: () => githubConnections,
  messages: () => messages,
  portAllocations: () => portAllocations,
  projects: () => projects,
  railwayConnections: () => railwayConnections,
  railwayDeployments: () => railwayDeployments,
  runnerKeys: () => runnerKeys,
  runningProcesses: () => runningProcesses,
  serverOperations: () => serverOperations,
  sessions: () => sessions,
  users: () => users,
  verifications: () => verifications
});
import { pgTable, text, integer, timestamp, uuid, jsonb, index, uniqueIndex, boolean } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";
var users = pgTable("users", {
  id: uuid("id").primaryKey().defaultRandom(),
  name: text("name").notNull(),
  email: text("email").notNull().unique(),
  emailVerified: boolean("email_verified").notNull().default(false),
  image: text("image"),
  hasCompletedOnboarding: boolean("has_completed_onboarding").notNull().default(false),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
});
var sessions = pgTable("sessions", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  token: text("token").notNull().unique(),
  expiresAt: timestamp("expires_at").notNull(),
  ipAddress: text("ip_address"),
  userAgent: text("user_agent"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  userIdIdx: index("sessions_user_id_idx").on(table.userId),
  tokenIdx: index("sessions_token_idx").on(table.token)
}));
var accounts = pgTable("accounts", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  accountId: text("account_id").notNull(),
  providerId: text("provider_id").notNull(),
  // 'credential', 'google', etc.
  accessToken: text("access_token"),
  refreshToken: text("refresh_token"),
  accessTokenExpiresAt: timestamp("access_token_expires_at"),
  refreshTokenExpiresAt: timestamp("refresh_token_expires_at"),
  scope: text("scope"),
  idToken: text("id_token"),
  // ID token from OAuth providers
  password: text("password"),
  // Hashed password for credential provider
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  userIdIdx: index("accounts_user_id_idx").on(table.userId),
  providerAccountIdx: uniqueIndex("accounts_provider_account_idx").on(table.providerId, table.accountId)
}));
var verifications = pgTable("verifications", {
  id: uuid("id").primaryKey().defaultRandom(),
  identifier: text("identifier").notNull(),
  // email or other identifier
  value: text("value").notNull(),
  // verification token
  expiresAt: timestamp("expires_at").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  identifierIdx: index("verifications_identifier_idx").on(table.identifier)
}));
var runnerKeys = pgTable("runner_keys", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  // User-friendly name like "My MacBook"
  keyHash: text("key_hash").notNull(),
  // SHA-256 hash of the full key
  keyPrefix: text("key_prefix").notNull(),
  // First 8 chars for display: "sv_abc123..."
  source: text("source").default("web"),
  // 'web' | 'cli' - how the key was created
  lastUsedAt: timestamp("last_used_at"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  revokedAt: timestamp("revoked_at")
  // Soft delete - null means active
}, (table) => ({
  userIdIdx: index("runner_keys_user_id_idx").on(table.userId),
  keyHashIdx: uniqueIndex("runner_keys_key_hash_idx").on(table.keyHash)
}));
var cliAuthSessions = pgTable("cli_auth_sessions", {
  id: uuid("id").primaryKey().defaultRandom(),
  token: text("token").notNull().unique(),
  // Random token for session identification
  callbackPort: integer("callback_port").notNull(),
  // Port the CLI is listening on
  callbackHost: text("callback_host").default("localhost"),
  // Host for callback
  state: text("state").notNull().default("pending"),
  // 'pending' | 'authenticated' | 'completed' | 'expired'
  userId: uuid("user_id").references(() => users.id, { onDelete: "cascade" }),
  // Set after auth
  runnerKeyId: uuid("runner_key_id").references(() => runnerKeys.id, { onDelete: "cascade" }),
  // Created key
  deviceName: text("device_name"),
  // Auto-detected device name
  expiresAt: timestamp("expires_at").notNull(),
  // Session expiration (short-lived)
  createdAt: timestamp("created_at").notNull().defaultNow(),
  authenticatedAt: timestamp("authenticated_at")
  // When user completed OAuth
}, (table) => ({
  tokenIdx: uniqueIndex("cli_auth_sessions_token_idx").on(table.token),
  expiresAtIdx: index("cli_auth_sessions_expires_at_idx").on(table.expiresAt)
}));
var projects = pgTable("projects", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").references(() => users.id, { onDelete: "set null" }),
  // Owner of the project (nullable for migration/local mode)
  name: text("name").notNull(),
  slug: text("slug").notNull().unique(),
  description: text("description"),
  originalPrompt: text("original_prompt"),
  icon: text("icon").default("Folder"),
  status: text("status").notNull().default("pending"),
  projectType: text("project_type"),
  detectedFramework: text("detected_framework"),
  // Auto-detected framework (astro, next, vite, etc.)
  path: text("path"),
  // Nullable - deprecated, path should be calculated from slug
  runCommand: text("run_command"),
  port: integer("port"),
  devServerPid: integer("dev_server_pid"),
  devServerPort: integer("dev_server_port"),
  devServerStatus: text("dev_server_status").default("stopped"),
  devServerStatusUpdatedAt: timestamp("dev_server_status_updated_at").defaultNow(),
  tunnelUrl: text("tunnel_url"),
  runnerId: text("runner_id"),
  // Runner that created/manages this project
  generationState: text("generation_state"),
  designPreferences: jsonb("design_preferences"),
  // User-specified design constraints (deprecated - use tags)
  tags: jsonb("tags"),
  // Tag-based configuration system
  lastActivityAt: timestamp("last_activity_at").defaultNow(),
  errorMessage: text("error_message"),
  // GitHub integration fields
  githubRepo: text("github_repo"),
  // e.g., "owner/repo-name"
  githubUrl: text("github_url"),
  // Full repository URL
  githubBranch: text("github_branch"),
  // Default branch (e.g., "main")
  githubLastPushedAt: timestamp("github_last_pushed_at"),
  // Last push timestamp
  githubAutoPush: boolean("github_auto_push").default(false),
  // Auto-push after builds
  githubLastSyncAt: timestamp("github_last_sync_at"),
  // Last time we synced repo info
  githubMeta: jsonb("github_meta"),
  // Additional metadata (issues count, recent commits, etc.)
  // NeonDB integration fields
  neondbConnectionString: text("neondb_connection_string"),
  // DATABASE_URL (encrypted/partial)
  neondbClaimUrl: text("neondb_claim_url"),
  // URL to claim the database
  neondbHost: text("neondb_host"),
  // Database host endpoint
  neondbDatabase: text("neondb_database"),
  // Database name
  neondbCreatedAt: timestamp("neondb_created_at"),
  // When database was provisioned
  neondbExpiresAt: timestamp("neondb_expires_at"),
  // When unclaimed DB expires (72 hours)
  // Railway integration fields
  railwayProjectId: text("railway_project_id"),
  // Railway project ID
  railwayServiceId: text("railway_service_id"),
  // Railway service ID
  railwayEnvironmentId: text("railway_environment_id"),
  // Railway environment ID (production)
  railwayDomain: text("railway_domain"),
  // e.g., "myapp-production.up.railway.app"
  railwayDeploymentStatus: text("railway_deployment_status"),
  // 'deploying' | 'success' | 'failed' | 'crashed'
  railwayLastDeployedAt: timestamp("railway_last_deployed_at"),
  // Last successful deployment
  // Execution mode: where builds run for this project
  executionMode: text("execution_mode").default("sandbox"),
  // 'sandbox' (default) | 'local'
  sandboxId: text("sandbox_id"),
  // Railway sandbox id when executionMode='sandbox' and currently running (warm)
  sandboxStatus: text("sandbox_status"),
  // 'provisioning' | 'running' | 'stopped' | 'failed'
  sandboxCheckpoint: text("sandbox_checkpoint"),
  // Railway checkpoint key for this project's saved workspace (restore point)
  sandboxSubdomain: text("sandbox_subdomain"),
  // Stable railgate subdomain so the preview URL persists across restarts
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  // Indexes for performance
  userIdIdx: index("projects_user_id_idx").on(table.userId),
  runnerIdIdx: index("projects_runner_id_idx").on(table.runnerId),
  statusIdx: index("projects_status_idx").on(table.status),
  lastActivityIdx: index("projects_last_activity_idx").on(table.lastActivityAt)
}));
var messages = pgTable("messages", {
  id: uuid("id").primaryKey().defaultRandom(),
  projectId: uuid("project_id").notNull().references(() => projects.id, { onDelete: "cascade" }),
  role: text("role").notNull(),
  content: text("content").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow()
});
var portAllocations = pgTable("port_allocations", {
  port: integer("port").primaryKey(),
  framework: text("framework").notNull(),
  projectId: uuid("project_id").references(() => projects.id, { onDelete: "set null" }),
  reservedAt: timestamp("reserved_at").defaultNow()
});
var runningProcesses = pgTable("running_processes", {
  projectId: uuid("project_id").primaryKey().notNull().references(() => projects.id, { onDelete: "cascade" }),
  pid: integer("pid").notNull(),
  port: integer("port"),
  command: text("command"),
  runnerId: text("runner_id"),
  // Runner that manages this process
  startedAt: timestamp("started_at").notNull().defaultNow(),
  lastHealthCheck: timestamp("last_health_check"),
  healthCheckFailCount: integer("health_check_fail_count").notNull().default(0)
}, (table) => ({
  // Index for filtering by runner
  runnerIdIdx: index("running_processes_runner_id_idx").on(table.runnerId)
}));
var generationSessions = pgTable("generation_sessions", {
  id: uuid("id").primaryKey().defaultRandom(),
  projectId: uuid("project_id").notNull().references(() => projects.id, { onDelete: "cascade" }),
  requestMessageId: uuid("request_message_id").references(() => messages.id, { onDelete: "set null" }),
  buildId: text("build_id").notNull(),
  operationType: text("operation_type"),
  status: text("status").notNull().default("active"),
  startedAt: timestamp("started_at").notNull().defaultNow(),
  endedAt: timestamp("ended_at"),
  summary: text("summary"),
  rawState: jsonb("raw_state"),
  isAutoFix: boolean("is_auto_fix").default(false),
  // Flag for auto-fix sessions triggered by startup errors
  autoFixError: text("auto_fix_error"),
  // The error message that triggered the auto-fix
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  projectIdIdx: index("generation_sessions_project_id_idx").on(table.projectId),
  requestMessageIdIdx: index("generation_sessions_request_message_id_idx").on(table.requestMessageId),
  buildIdUnique: uniqueIndex("generation_sessions_build_id_unique").on(table.buildId)
}));
var generationTodos = pgTable("generation_todos", {
  id: uuid("id").primaryKey().defaultRandom(),
  sessionId: uuid("session_id").notNull().references(() => generationSessions.id, { onDelete: "cascade" }),
  todoIndex: integer("todo_index").notNull(),
  content: text("content").notNull(),
  activeForm: text("active_form"),
  status: text("status").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  sessionIdIdx: index("generation_todos_session_id_idx").on(table.sessionId),
  sessionIndexUnique: uniqueIndex("generation_todos_session_index_unique").on(table.sessionId, table.todoIndex)
}));
var generationToolCalls = pgTable("generation_tool_calls", {
  id: uuid("id").primaryKey().defaultRandom(),
  sessionId: uuid("session_id").notNull().references(() => generationSessions.id, { onDelete: "cascade" }),
  todoIndex: integer("todo_index").notNull(),
  toolCallId: text("tool_call_id").notNull(),
  name: text("name").notNull(),
  input: jsonb("input"),
  output: jsonb("output"),
  state: text("state").notNull(),
  startedAt: timestamp("started_at").notNull().defaultNow(),
  endedAt: timestamp("ended_at"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  sessionIdIdx: index("generation_tool_calls_session_id_idx").on(table.sessionId),
  toolCallUnique: uniqueIndex("generation_tool_calls_call_id_unique").on(table.sessionId, table.toolCallId)
}));
var generationNotes = pgTable("generation_notes", {
  id: uuid("id").primaryKey().defaultRandom(),
  sessionId: uuid("session_id").notNull().references(() => generationSessions.id, { onDelete: "cascade" }),
  todoIndex: integer("todo_index").notNull(),
  textId: text("text_id"),
  kind: text("kind").notNull().default("text"),
  content: text("content").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow()
}, (table) => ({
  sessionIdIdx: index("generation_notes_session_id_idx").on(table.sessionId),
  textIdUnique: uniqueIndex("generation_notes_text_id_unique").on(table.sessionId, table.textId).where(sql`${table.textId} is not null`)
}));
var buildMetrics = pgTable("build_metrics", {
  id: uuid("id").primaryKey().defaultRandom(),
  projectId: uuid("project_id").notNull().references(() => projects.id, { onDelete: "cascade" }),
  sessionId: uuid("session_id").references(() => generationSessions.id, { onDelete: "set null" }),
  buildId: text("build_id"),
  commandId: text("command_id"),
  status: text("status").notNull(),
  // 'completed' | 'failed'
  agent: text("agent"),
  model: text("model"),
  totalMs: integer("total_ms"),
  orchestrationMs: integer("orchestration_ms"),
  agentMs: integer("agent_ms"),
  timeToFirstChunkMs: integer("time_to_first_chunk_ms"),
  runnerOverheadMs: integer("runner_overhead_ms"),
  totalTokens: integer("total_tokens"),
  inputTokens: integer("input_tokens"),
  outputTokens: integer("output_tokens"),
  cacheReadInputTokens: integer("cache_read_input_tokens"),
  cacheCreationInputTokens: integer("cache_creation_input_tokens"),
  numTurns: integer("num_turns"),
  totalCostUsd: text("total_cost_usd"),
  dependencyInstallTotalMs: integer("dependency_install_total_ms"),
  dependencyInstallCalls: integer("dependency_install_calls"),
  modifiedFileCount: integer("modified_file_count"),
  completedTodoCount: integer("completed_todo_count"),
  error: text("error"),
  metrics: jsonb("metrics").notNull(),
  createdAt: timestamp("created_at").notNull().defaultNow()
}, (table) => ({
  projectIdIdx: index("build_metrics_project_id_idx").on(table.projectId),
  sessionIdIdx: index("build_metrics_session_id_idx").on(table.sessionId),
  buildIdIdx: index("build_metrics_build_id_idx").on(table.buildId),
  createdAtIdx: index("build_metrics_created_at_idx").on(table.createdAt),
  // Postgres UNIQUE allows multiple NULLs, so missing commandIds still insert.
  commandIdUnique: uniqueIndex("build_metrics_command_id_unique").on(table.commandId)
}));
var railwayConnections = pgTable("railway_connections", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  // Encrypted OAuth tokens
  accessTokenEncrypted: text("access_token_encrypted").notNull(),
  refreshTokenEncrypted: text("refresh_token_encrypted"),
  accessTokenExpiresAt: timestamp("access_token_expires_at"),
  // Railway user info (from OAuth)
  railwayUserId: text("railway_user_id").notNull(),
  // "sub" claim from OIDC
  railwayEmail: text("railway_email"),
  railwayName: text("railway_name"),
  // Selected workspaces from OAuth consent
  defaultWorkspaceId: text("default_workspace_id"),
  defaultWorkspaceName: text("default_workspace_name"),
  grantedWorkspaces: jsonb("granted_workspaces").$type(),
  // Connection status
  status: text("status").notNull().default("active"),
  // 'active' | 'disconnected' | 'expired'
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  userIdUnique: uniqueIndex("railway_connections_user_id_unique").on(table.userId),
  railwayUserIdIdx: index("railway_connections_railway_user_id_idx").on(table.railwayUserId)
}));
var railwayDeployments = pgTable("railway_deployments", {
  id: uuid("id").primaryKey().defaultRandom(),
  projectId: uuid("project_id").notNull().references(() => projects.id, { onDelete: "cascade" }),
  // Railway resource IDs
  railwayProjectId: text("railway_project_id").notNull(),
  railwayServiceId: text("railway_service_id").notNull(),
  railwayDeploymentId: text("railway_deployment_id").notNull(),
  railwayEnvironmentId: text("railway_environment_id"),
  // Deployment info
  status: text("status").notNull(),
  // Railway deployment status
  url: text("url"),
  // Deployment URL
  commitSha: text("commit_sha"),
  // Git commit deployed
  // Timestamps
  deployedAt: timestamp("deployed_at").notNull().defaultNow(),
  completedAt: timestamp("completed_at"),
  createdAt: timestamp("created_at").notNull().defaultNow()
}, (table) => ({
  projectIdIdx: index("railway_deployments_project_id_idx").on(table.projectId),
  railwayDeploymentIdIdx: index("railway_deployments_railway_deployment_id_idx").on(table.railwayDeploymentId)
}));
var githubConnections = pgTable("github_connections", {
  id: uuid("id").primaryKey().defaultRandom(),
  userId: uuid("user_id").notNull().references(() => users.id, { onDelete: "cascade" }),
  // Encrypted OAuth tokens
  accessTokenEncrypted: text("access_token_encrypted").notNull(),
  // GitHub user info (from OAuth)
  githubUserId: text("github_user_id").notNull(),
  // GitHub user ID
  githubUsername: text("github_username").notNull(),
  // GitHub username/login
  githubEmail: text("github_email"),
  githubAvatarUrl: text("github_avatar_url"),
  // OAuth scopes granted
  scopes: text("scopes"),
  // Comma-separated list of scopes
  // Connection status
  status: text("status").notNull().default("active"),
  // 'active' | 'disconnected' | 'expired'
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow()
}, (table) => ({
  userIdUnique: uniqueIndex("github_connections_user_id_unique").on(table.userId),
  githubUserIdIdx: index("github_connections_github_user_id_idx").on(table.githubUserId)
}));
var serverOperations = pgTable("server_operations", {
  id: uuid("id").primaryKey().defaultRandom(),
  projectId: uuid("project_id").notNull().references(() => projects.id, { onDelete: "cascade" }),
  operation: text("operation").notNull(),
  // 'start', 'stop', 'restart'
  status: text("status").notNull().default("pending"),
  // 'pending', 'sent', 'ack', 'completed', 'failed', 'timeout'
  runnerId: text("runner_id"),
  port: integer("port"),
  pid: integer("pid"),
  error: text("error"),
  failureReason: text("failure_reason"),
  // 'port_in_use', 'health_check_timeout', 'immediate_crash', etc.
  retryCount: integer("retry_count").notNull().default(0),
  metadata: jsonb("metadata"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  sentAt: timestamp("sent_at"),
  ackAt: timestamp("ack_at"),
  completedAt: timestamp("completed_at")
}, (table) => ({
  projectIdIdx: index("server_operations_project_id_idx").on(table.projectId),
  statusIdx: index("server_operations_status_idx").on(table.status),
  createdAtIdx: index("server_operations_created_at_idx").on(table.createdAt)
}));

// src/lib/db/client.ts
var { Pool } = pg;
function createPostgresClient() {
  const connectionString = process.env.DATABASE_URL;
  if (!connectionString) {
    throw new Error(
      'DATABASE_URL is not set. Please configure your database connection:\n  - Run "hatchway init" to set up a Neon database\n  - Or set DATABASE_URL environment variable to your PostgreSQL connection string'
    );
  }
  const pool = new Pool({
    connectionString,
    ssl: process.env.PGSSLMODE === "disable" ? false : { rejectUnauthorized: false }
  });
  const client = drizzle(pool, { schema: schema_exports });
  return client;
}
async function initializeDatabase() {
  if (global.__db) {
    return global.__db;
  }
  const client = createPostgresClient();
  global.__db = client;
  return client;
}
async function getDb() {
  if (global.__db) {
    return global.__db;
  }
  return initializeDatabase();
}
function resetDatabase() {
  global.__db = void 0;
}
var db = new Proxy({}, {
  get(_target, prop) {
    if (!global.__db) {
      global.__db = createPostgresClient();
    }
    return global.__db[prop];
  }
});

// src/lib/websocket/server.ts
import { eq, and, isNull, desc } from "drizzle-orm";
import { createHash } from "crypto";

// src/lib/websocket/http-proxy-manager.ts
import { randomUUID } from "crypto";
var CHUNK_SIZE = 64 * 1024;
var REQUEST_TIMEOUT_MS = 3e4;
var MAX_SINGLE_RESPONSE_SIZE = 1024 * 1024;
var HttpProxyManager = class {
  pendingRequests = /* @__PURE__ */ new Map();
  /**
   * Proxy an HTTP request through the WebSocket connection to a runner
   */
  async proxyRequest(runnerId, projectId, port, request) {
    const requestId = randomUUID();
    if (!buildWebSocketServer.isRunnerConnected(runnerId)) {
      throw new Error(`Runner ${runnerId} is not connected`);
    }
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        const pending = this.pendingRequests.get(requestId);
        if (pending) {
          this.pendingRequests.delete(requestId);
          reject(new Error(`HTTP proxy request timeout after ${REQUEST_TIMEOUT_MS}ms`));
        }
      }, REQUEST_TIMEOUT_MS);
      this.pendingRequests.set(requestId, {
        resolve,
        reject,
        timeout,
        chunks: [],
        runnerId
      });
      const command = {
        id: randomUUID(),
        type: "http-proxy-request",
        projectId,
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        payload: {
          requestId,
          method: request.method,
          path: request.path,
          headers: request.headers,
          body: request.body ? request.body.toString("base64") : null,
          port
        }
      };
      const sent = buildWebSocketServer.sendCommandToRunner(runnerId, command);
      if (!sent) {
        clearTimeout(timeout);
        this.pendingRequests.delete(requestId);
        reject(new Error(`Failed to send HTTP proxy request to runner ${runnerId}`));
      }
    });
  }
  /**
   * Handle HTTP proxy response event from runner
   */
  handleProxyResponse(event) {
    const pending = this.pendingRequests.get(event.requestId);
    if (!pending) {
      console.warn(`[http-proxy] Received response for unknown request: ${event.requestId}`);
      return;
    }
    pending.headers = event.headers;
    pending.statusCode = event.statusCode;
    if (!event.isChunked && event.body !== void 0) {
      clearTimeout(pending.timeout);
      this.pendingRequests.delete(event.requestId);
      pending.resolve({
        statusCode: event.statusCode,
        headers: event.headers,
        body: Buffer.from(event.body, "base64")
      });
    }
  }
  /**
   * Handle HTTP proxy chunk event from runner
   */
  handleProxyChunk(event) {
    const pending = this.pendingRequests.get(event.requestId);
    if (!pending) {
      console.warn(`[http-proxy] Received chunk for unknown request: ${event.requestId}`);
      return;
    }
    pending.chunks.push(Buffer.from(event.chunk, "base64"));
    if (event.isFinal) {
      clearTimeout(pending.timeout);
      this.pendingRequests.delete(event.requestId);
      const body = Buffer.concat(pending.chunks);
      pending.resolve({
        statusCode: pending.statusCode || 200,
        headers: pending.headers || {},
        body
      });
    }
  }
  /**
   * Handle HTTP proxy error event from runner
   */
  handleProxyError(event) {
    const pending = this.pendingRequests.get(event.requestId);
    if (!pending) {
      console.warn(`[http-proxy] Received error for unknown request: ${event.requestId}`);
      return;
    }
    clearTimeout(pending.timeout);
    this.pendingRequests.delete(event.requestId);
    const error = new Error(event.error);
    error.statusCode = event.statusCode;
    pending.reject(error);
  }
  /**
   * Process a runner event and handle HTTP proxy events
   */
  processEvent(event) {
    switch (event.type) {
      case "http-proxy-response":
        this.handleProxyResponse(event);
        return true;
      case "http-proxy-chunk":
        this.handleProxyChunk(event);
        return true;
      case "http-proxy-error":
        this.handleProxyError(event);
        return true;
      default:
        return false;
    }
  }
  /**
   * Cancel all pending requests for a specific runner (e.g., on disconnect)
   */
  cancelRequestsForRunner(runnerId) {
    for (const [requestId, pending] of this.pendingRequests.entries()) {
      if (pending.runnerId === runnerId) {
        clearTimeout(pending.timeout);
        pending.reject(new Error("Runner disconnected"));
        this.pendingRequests.delete(requestId);
      }
    }
  }
  /**
   * Get stats about pending requests
   */
  getStats() {
    return {
      pendingRequests: this.pendingRequests.size,
      requestsByRunner: Array.from(this.pendingRequests.values()).reduce((acc, req) => {
        acc[req.runnerId] = (acc[req.runnerId] || 0) + 1;
        return acc;
      }, {})
    };
  }
};
var globalKey = "__httpProxyManager__";
function getOrCreateManager() {
  if (!globalThis[globalKey]) {
    globalThis[globalKey] = new HttpProxyManager();
  }
  return globalThis[globalKey];
}
var httpProxyManager = getOrCreateManager();

// src/lib/websocket/hmr-proxy-manager.ts
import { randomUUID as randomUUID2 } from "crypto";
var CONNECTION_TIMEOUT_MS = 3e4;
var HmrProxyManager = class {
  // Map connectionId -> pending connection info
  connections = /* @__PURE__ */ new Map();
  /**
   * Initiate an HMR connection through the runner
   * 
   * @param connectionId - Connection ID from frontend (must be preserved for message correlation)
   * @returns connectionId to track this connection
   */
  connect(connectionId, runnerId, projectId, port, protocol, callbacks) {
    if (!buildWebSocketServer.isRunnerConnected(runnerId)) {
      console.warn(`[hmr-proxy] Runner ${runnerId} is not connected`);
      callbacks?.onError?.("Runner not connected");
      return connectionId;
    }
    this.connections.set(connectionId, {
      projectId,
      runnerId,
      port,
      protocol,
      status: "connecting",
      createdAt: Date.now(),
      ...callbacks
    });
    setTimeout(() => {
      const conn = this.connections.get(connectionId);
      if (conn && conn.status === "connecting") {
        console.warn(`[hmr-proxy] Connection timeout for ${connectionId}`);
        conn.status = "error";
        conn.onError?.("Connection timeout");
        this.connections.delete(connectionId);
      }
    }, CONNECTION_TIMEOUT_MS);
    const command = {
      id: randomUUID2(),
      type: "hmr-connect",
      projectId,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: {
        connectionId,
        port,
        protocol
      }
    };
    const sent = buildWebSocketServer.sendCommandToRunner(runnerId, command);
    if (!sent) {
      console.error(`[hmr-proxy] Failed to send HMR connect to runner ${runnerId}`);
      this.connections.delete(connectionId);
      callbacks?.onError?.("Failed to send connect command");
    }
    return connectionId;
  }
  /**
   * Send an HMR message through the connection
   */
  send(connectionId, message) {
    const conn = this.connections.get(connectionId);
    if (!conn) {
      console.warn(`[hmr-proxy] No connection found for ${connectionId}`);
      return false;
    }
    if (conn.status !== "connected") {
      console.warn(`[hmr-proxy] Connection ${connectionId} not ready (${conn.status})`);
      return false;
    }
    const command = {
      id: randomUUID2(),
      type: "hmr-message",
      projectId: conn.projectId,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: {
        connectionId,
        message
      }
    };
    return buildWebSocketServer.sendCommandToRunner(conn.runnerId, command);
  }
  /**
   * Disconnect an HMR connection
   */
  disconnect(connectionId) {
    const conn = this.connections.get(connectionId);
    if (!conn) {
      return;
    }
    const command = {
      id: randomUUID2(),
      type: "hmr-disconnect",
      projectId: conn.projectId,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: {
        connectionId
      }
    };
    buildWebSocketServer.sendCommandToRunner(conn.runnerId, command);
    this.connections.delete(connectionId);
  }
  /**
   * Handle HMR events from runner
   */
  handleConnected(event) {
    const conn = this.connections.get(event.connectionId);
    if (!conn) {
      console.warn(`[hmr-proxy] Received connected for unknown connection: ${event.connectionId}`);
      return;
    }
    conn.status = "connected";
    conn.onConnected?.();
  }
  handleMessage(event) {
    const conn = this.connections.get(event.connectionId);
    if (!conn) {
      console.warn(`[hmr-proxy] Received message for unknown connection: ${event.connectionId}`);
      return;
    }
    conn.onMessage?.(event.message);
  }
  handleDisconnected(event) {
    const conn = this.connections.get(event.connectionId);
    if (!conn) {
      console.warn(`[hmr-proxy] Received disconnected for unknown connection: ${event.connectionId}`);
      return;
    }
    conn.status = "disconnected";
    conn.onDisconnected?.(event.code, event.reason);
    this.connections.delete(event.connectionId);
  }
  handleError(event) {
    const conn = this.connections.get(event.connectionId);
    if (!conn) {
      console.warn(`[hmr-proxy] Received error for unknown connection: ${event.connectionId}`);
      return;
    }
    console.error(`[hmr-proxy] HMR error for ${event.connectionId}: ${event.error}`);
    conn.status = "error";
    conn.onError?.(event.error);
    this.connections.delete(event.connectionId);
  }
  /**
   * Process a runner event and handle HMR events
   * @returns true if the event was an HMR event and was handled
   */
  processEvent(event) {
    switch (event.type) {
      case "hmr-connected":
        this.handleConnected(event);
        return true;
      case "hmr-message":
        this.handleMessage(event);
        return true;
      case "hmr-disconnected":
        this.handleDisconnected(event);
        return true;
      case "hmr-error":
        this.handleError(event);
        return true;
      default:
        return false;
    }
  }
  /**
   * Disconnect all HMR connections for a project
   */
  disconnectProject(projectId) {
    for (const [connectionId, conn] of this.connections.entries()) {
      if (conn.projectId === projectId) {
        this.disconnect(connectionId);
      }
    }
  }
  /**
   * Disconnect all HMR connections for a runner (e.g., on runner disconnect)
   */
  disconnectRunner(runnerId) {
    for (const [connectionId, conn] of this.connections.entries()) {
      if (conn.runnerId === runnerId) {
        conn.onDisconnected?.(1001, "Runner disconnected");
        this.connections.delete(connectionId);
      }
    }
  }
  /**
   * Get connection by ID
   */
  getConnection(connectionId) {
    return this.connections.get(connectionId);
  }
  /**
   * Get stats about active connections
   */
  getStats() {
    return {
      activeConnections: this.connections.size,
      connectionsByProject: Array.from(this.connections.values()).reduce((acc, conn) => {
        acc[conn.projectId] = (acc[conn.projectId] || 0) + 1;
        return acc;
      }, {}),
      connectionsByStatus: Array.from(this.connections.values()).reduce((acc, conn) => {
        acc[conn.status] = (acc[conn.status] || 0) + 1;
        return acc;
      }, {})
    };
  }
};
var globalKey2 = "__hmrProxyManager__";
function getOrCreateManager2() {
  if (!globalThis[globalKey2]) {
    globalThis[globalKey2] = new HmrProxyManager();
  }
  return globalThis[globalKey2];
}
var hmrProxyManager = getOrCreateManager2();

// src/lib/runner/command-queue.ts
var DEFAULT_OPTIONS = {
  maxQueueSize: 100,
  defaultTtlMs: 5 * 60 * 1e3,
  // 5 minutes
  defaultMaxAttempts: 3,
  cleanupIntervalMs: 30 * 1e3
  // 30 seconds
};
var RunnerCommandQueue = class {
  queues = /* @__PURE__ */ new Map();
  options;
  cleanupInterval = null;
  sendFunction = null;
  constructor(options = {}) {
    this.options = { ...DEFAULT_OPTIONS, ...options };
    this.startCleanup();
  }
  /**
   * Set the function used to send commands to runners
   * This is injected to avoid circular dependencies with WebSocket server
   */
  setSendFunction(fn) {
    this.sendFunction = fn;
  }
  /**
   * Queue a command for delivery to a runner
   * Returns true if command was sent immediately, false if queued
   */
  enqueue(runnerId, command, options = {}) {
    const queuedCommand = {
      command,
      runnerId,
      queuedAt: Date.now(),
      attempts: 0,
      maxAttempts: options.maxAttempts ?? this.options.defaultMaxAttempts,
      ttlMs: options.ttlMs ?? this.options.defaultTtlMs,
      onSuccess: options.onSuccess,
      onFailure: options.onFailure
    };
    if (this.sendFunction) {
      const sent = this.trySend(queuedCommand);
      if (sent) {
        return { sent: true, queued: false };
      }
    }
    return this.addToQueue(runnerId, queuedCommand);
  }
  /**
   * Try to send a command, returns true if successful
   */
  trySend(queuedCommand) {
    if (!this.sendFunction) {
      return false;
    }
    queuedCommand.attempts++;
    const sent = this.sendFunction(queuedCommand.runnerId, queuedCommand.command);
    if (sent) {
      buildLogger.log("debug", "websocket", `[command-queue] Command sent: ${queuedCommand.command.type}`, {
        runnerId: queuedCommand.runnerId,
        commandId: queuedCommand.command.id,
        attempts: queuedCommand.attempts
      });
      queuedCommand.onSuccess?.();
      return true;
    }
    return false;
  }
  /**
   * Add a command to the queue
   */
  addToQueue(runnerId, queuedCommand) {
    let queue = this.queues.get(runnerId);
    if (!queue) {
      queue = [];
      this.queues.set(runnerId, queue);
    }
    if (queue.length >= this.options.maxQueueSize) {
      buildLogger.log("warn", "websocket", `Queue full for runner ${runnerId}, dropping oldest command`);
      const dropped = queue.shift();
      dropped?.onFailure?.("Queue full - command dropped");
    }
    queue.push(queuedCommand);
    buildLogger.log("debug", "websocket", `Command queued: ${queuedCommand.command.type}`, {
      runnerId,
      commandId: queuedCommand.command.id,
      queueSize: queue.length
    });
    return { sent: false, queued: true };
  }
  /**
   * Process queued commands for a runner (call when runner connects/reconnects)
   */
  processQueue(runnerId) {
    const queue = this.queues.get(runnerId);
    if (!queue || queue.length === 0) {
      return { sent: 0, failed: 0, remaining: 0 };
    }
    let sent = 0;
    let failed = 0;
    const remaining = [];
    for (const queuedCommand of queue) {
      if (this.isExpired(queuedCommand)) {
        buildLogger.log("debug", "websocket", `Command expired: ${queuedCommand.command.type}`, {
          runnerId,
          commandId: queuedCommand.command.id
        });
        queuedCommand.onFailure?.("Command expired");
        failed++;
        continue;
      }
      if (queuedCommand.attempts >= queuedCommand.maxAttempts) {
        buildLogger.log("debug", "websocket", `Command max attempts reached: ${queuedCommand.command.type}`, {
          runnerId,
          commandId: queuedCommand.command.id,
          attempts: queuedCommand.attempts
        });
        queuedCommand.onFailure?.("Max retry attempts reached");
        failed++;
        continue;
      }
      if (this.trySend(queuedCommand)) {
        sent++;
      } else {
        remaining.push(queuedCommand);
      }
    }
    if (remaining.length > 0) {
      this.queues.set(runnerId, remaining);
    } else {
      this.queues.delete(runnerId);
    }
    buildLogger.log("info", "websocket", `Processed queue for runner ${runnerId}`, {
      sent,
      failed,
      remaining: remaining.length
    });
    return { sent, failed, remaining: remaining.length };
  }
  /**
   * Check if a command has expired
   */
  isExpired(queuedCommand) {
    return Date.now() - queuedCommand.queuedAt > queuedCommand.ttlMs;
  }
  /**
   * Start the cleanup interval for expired commands
   */
  startCleanup() {
    this.cleanupInterval = setInterval(() => {
      this.cleanup();
    }, this.options.cleanupIntervalMs);
  }
  /**
   * Clean up expired commands from all queues
   */
  cleanup() {
    for (const [runnerId, queue] of this.queues.entries()) {
      const validCommands = queue.filter((cmd) => {
        if (this.isExpired(cmd)) {
          cmd.onFailure?.("Command expired");
          return false;
        }
        return true;
      });
      if (validCommands.length !== queue.length) {
        buildLogger.log("debug", "websocket", `Cleaned ${queue.length - validCommands.length} expired commands for runner ${runnerId}`);
      }
      if (validCommands.length === 0) {
        this.queues.delete(runnerId);
      } else {
        this.queues.set(runnerId, validCommands);
      }
    }
  }
  /**
   * Get queue stats
   */
  getStats() {
    const runnerQueues = {};
    let totalQueued = 0;
    for (const [runnerId, queue] of this.queues.entries()) {
      runnerQueues[runnerId] = queue.length;
      totalQueued += queue.length;
    }
    return { totalQueued, runnerQueues };
  }
  /**
   * Clear all queued commands for a runner
   */
  clearQueue(runnerId) {
    const queue = this.queues.get(runnerId);
    const count = queue?.length ?? 0;
    if (queue) {
      for (const cmd of queue) {
        cmd.onFailure?.("Queue cleared");
      }
    }
    this.queues.delete(runnerId);
    return count;
  }
  /**
   * Shutdown the queue (cleanup interval)
   */
  shutdown() {
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
      this.cleanupInterval = null;
    }
  }
};
var commandQueue = new RunnerCommandQueue();

// src/lib/timing-safe-equal.ts
import { timingSafeEqual } from "crypto";
function timingSafeEqualString(a, b) {
  const bufA = Buffer.from(a);
  const bufB = Buffer.from(b);
  if (bufA.length !== bufB.length) {
    return false;
  }
  return timingSafeEqual(bufA, bufB);
}

// src/lib/websocket/server.ts
var isLocalMode = () => process.env.HATCHWAY_LOCAL_MODE === "true";
var upgradeAuthContext = /* @__PURE__ */ new WeakMap();
var getSharedSecret = () => process.env.RUNNER_SHARED_SECRET;
function hashRunnerKey(key) {
  return createHash("sha256").update(key).digest("hex");
}
async function validateRunnerKey(key) {
  if (!key || !key.startsWith("sv_")) {
    return { valid: false };
  }
  const keyHash = hashRunnerKey(key);
  try {
    const results = await db.select({ id: runnerKeys.id, userId: runnerKeys.userId }).from(runnerKeys).where(
      and(
        eq(runnerKeys.keyHash, keyHash),
        isNull(runnerKeys.revokedAt)
      )
    ).limit(1);
    if (results.length > 0) {
      db.update(runnerKeys).set({ lastUsedAt: /* @__PURE__ */ new Date() }).where(eq(runnerKeys.id, results[0].id)).execute().catch(() => {
      });
      return { valid: true, userId: results[0].userId };
    }
  } catch (error) {
    console.error("[websocket] Error validating runner key:", error);
  }
  return { valid: false };
}
var BuildWebSocketServer = class {
  wss = null;
  runnerWss = null;
  clients = /* @__PURE__ */ new Map();
  runnerConnections = /* @__PURE__ */ new Map();
  pendingUpdates = /* @__PURE__ */ new Map();
  batchInterval = null;
  heartbeatInterval = null;
  runnerCleanupInterval = null;
  BATCH_DELAY = 200;
  // ms - batch updates for efficiency
  HEARTBEAT_INTERVAL = 3e4;
  // 30s
  CLIENT_TIMEOUT = 6e4;
  // 60s
  RUNNER_PING_INTERVAL = 3e4;
  // 30s
  RUNNER_HEARTBEAT_TIMEOUT = 9e4;
  // 90s
  // Metrics tracking for runner connections
  runnerTotalEvents = 0;
  runnerTotalCommands = 0;
  runnerTotalErrors = 0;
  // Instance ID for debugging singleton issues
  instanceId = Math.random().toString(36).substring(7);
  initialized = false;
  // Callback for runner status changes (set by app layer)
  onRunnerStatusChangeCallback = null;
  // Client auth hooks (set by app layer). Without these, client connections are
  // only accepted in local mode - default deny in hosted deployments.
  authenticateClient = null;
  authorizeProjectAccess = null;
  /**
   * Install authentication hooks for frontend client connections.
   * Must be called by the app layer before clients connect in hosted mode.
   */
  setClientAuth(authenticate, authorize) {
    this.authenticateClient = authenticate;
    this.authorizeProjectAccess = authorize;
  }
  constructor() {
    buildLogger.websocket.serverCreated(this.instanceId);
  }
  /**
   * Initialize WebSocket server for both frontend clients and runners
   */
  initialize(server, path = "/ws") {
    if (this.initialized) {
      buildLogger.log("debug", "websocket", `Server already initialized (instance: ${this.instanceId}), skipping...`, { instanceId: this.instanceId });
      return;
    }
    buildLogger.log("debug", "websocket", `Initializing server (instance: ${this.instanceId})...`, { instanceId: this.instanceId });
    this.initialized = true;
    this.wss = new WebSocketServer({
      noServer: true,
      perMessageDeflate: false
      // Disable compression for lower latency
    });
    this.wss.on("connection", (ws, req) => {
      this.handleConnection(ws, req).catch((error) => {
        buildLogger.websocket.error("Failed to handle client connection", error);
        try {
          ws.close(1011, "Internal error");
        } catch {
        }
      });
    });
    this.runnerWss = new WebSocketServer({
      noServer: true,
      perMessageDeflate: false
    });
    this.runnerWss.on("connection", (ws, req) => {
      this.handleRunnerConnection(ws, req);
    });
    server.on("upgrade", (request, socket, head) => {
      const pathname = request.url?.split("?")[0] || "";
      if (pathname === "/ws/runner") {
        this.runnerWss.handleUpgrade(request, socket, head, (ws) => {
          this.runnerWss.emit("connection", ws, request);
        });
      } else if (pathname === path || pathname === "/ws") {
        this.resolveClientAuth(request).then((auth) => {
          if (!auth.allowed) {
            buildLogger.log("warn", "websocket", "Rejected unauthenticated client upgrade");
            socket.write("HTTP/1.1 401 Unauthorized\r\nConnection: close\r\n\r\n");
            socket.destroy();
            return;
          }
          upgradeAuthContext.set(request, { userId: auth.userId });
          this.wss.handleUpgrade(request, socket, head, (ws) => {
            this.wss.emit("connection", ws, request);
          });
        }).catch((error) => {
          buildLogger.websocket.error("Client upgrade auth failed", error);
          socket.destroy();
        });
      } else {
        if (pathname && pathname !== "/") {
          buildLogger.websocket.unknownUpgradePath(pathname);
        }
        socket.destroy();
      }
    });
    this.batchInterval = setInterval(() => {
      this.processBatchedUpdates();
    }, this.BATCH_DELAY);
    this.heartbeatInterval = setInterval(() => {
      this.sendHeartbeats();
    }, this.HEARTBEAT_INTERVAL);
    this.runnerCleanupInterval = setInterval(() => {
      this.cleanupStaleRunnerConnections();
    }, 6e4);
    commandQueue.setSendFunction((runnerId, command) => {
      return this.sendCommandToRunner(runnerId, command);
    });
    buildLogger.websocket.serverInitialized(path, "/ws/runner");
  }
  // ============================================================
  // FRONTEND CLIENT HANDLING
  // ============================================================
  /**
   * Authenticate a client upgrade request.
   * Local mode: always allowed. Hosted mode: requires the app layer to have
   * installed an authenticator via setClientAuth() - otherwise deny.
   */
  async resolveClientAuth(req) {
    if (isLocalMode()) {
      return { allowed: true };
    }
    if (!this.authenticateClient) {
      buildLogger.log("warn", "websocket", "No client authenticator configured - denying client connection");
      return { allowed: false };
    }
    const auth = await this.authenticateClient(req);
    if (!auth) {
      return { allowed: false };
    }
    return { allowed: true, userId: auth.userId };
  }
  /**
   * Check whether a user may access a project. Local mode always allows.
   */
  async canAccessProject(userId, projectId) {
    if (isLocalMode()) return true;
    if (!this.authorizeProjectAccess || !userId) return false;
    try {
      return await this.authorizeProjectAccess(userId, projectId);
    } catch (error) {
      buildLogger.websocket.error("Project access check failed", error, { projectId });
      return false;
    }
  }
  /**
   * Handle new frontend WebSocket connection
   */
  async handleConnection(ws, req) {
    const clientId = this.generateClientId();
    const url = new URL(req.url || "", `http://${req.headers.host}`);
    const projectId = url.searchParams.get("projectId") || "";
    const sessionId = url.searchParams.get("sessionId") || void 0;
    const userId = upgradeAuthContext.get(req)?.userId;
    if (projectId && !await this.canAccessProject(userId, projectId)) {
      buildLogger.log("warn", "websocket", `Client denied access to project ${projectId}`);
      ws.close(4403, "Forbidden");
      return;
    }
    buildLogger.websocket.clientConnected(clientId, projectId, sessionId);
    this.clients.set(clientId, {
      ws,
      projectId,
      sessionId,
      userId,
      lastHeartbeat: Date.now()
    });
    this.sendMessage(ws, {
      type: "connected",
      clientId,
      projectId,
      sessionId,
      timestamp: Date.now()
    });
    ws.on("message", (data) => {
      try {
        const message = JSON.parse(data.toString());
        this.handleClientMessage(clientId, message).catch((error) => {
          buildLogger.websocket.error("Failed to handle client message", error, { clientId });
        });
      } catch (error) {
        buildLogger.websocket.error("Failed to parse client message", error, { clientId });
      }
    });
    ws.on("close", () => {
      buildLogger.websocket.clientDisconnected(clientId);
      const client = this.clients.get(clientId);
      if (client?.hmrConnections) {
        for (const connectionId of client.hmrConnections) {
          hmrProxyManager.disconnect(connectionId);
        }
      }
      this.clients.delete(clientId);
    });
    ws.on("error", (error) => {
      buildLogger.websocket.error("Client error", error, { clientId });
      this.clients.delete(clientId);
    });
  }
  // ============================================================
  // RUNNER CONNECTION HANDLING
  // ============================================================
  /**
   * Handle new runner WebSocket connection
   */
  async handleRunnerConnection(ws, req) {
    const sharedSecret = getSharedSecret();
    const authHeader = req.headers["authorization"];
    const token = authHeader?.startsWith("Bearer ") ? authHeader.substring(7) : authHeader;
    let isAuthenticated = false;
    let runnerUserId;
    if (token) {
      if (token.startsWith("sv_")) {
        const result = await validateRunnerKey(token);
        isAuthenticated = result.valid;
        runnerUserId = result.userId;
      } else if (sharedSecret && timingSafeEqualString(token, sharedSecret)) {
        isAuthenticated = true;
      }
    }
    if (!isAuthenticated) {
      if (!sharedSecret) {
        buildLogger.websocket.runnerAuthMissing();
        ws.close(1008, "Server misconfigured");
        return;
      }
      buildLogger.websocket.runnerAuthRejected();
      ws.close(1008, "Unauthorized");
      return;
    }
    const url = new URL(req.url || "", `http://${req.headers.host}`);
    const runnerId = url.searchParams.get("runnerId") ?? "default";
    const existing = this.runnerConnections.get(runnerId);
    if (existing) {
      if (existing.userId !== runnerUserId) {
        buildLogger.log("warn", "websocket", `Rejected runner connection: runnerId '${runnerId}' already claimed by another user`);
        ws.close(1008, "Runner ID already in use");
        return;
      }
      clearInterval(existing.pingInterval);
      try {
        existing.socket.close(1e3, "Replaced by new connection");
      } catch {
      }
    }
    buildLogger.websocket.runnerConnected(runnerId);
    const pingInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.ping();
      }
    }, this.RUNNER_PING_INTERVAL);
    this.runnerConnections.set(runnerId, {
      id: runnerId,
      socket: ws,
      lastHeartbeat: Date.now(),
      pingInterval,
      userId: runnerUserId
    });
    const queueResult = commandQueue.processQueue(runnerId);
    if (queueResult.sent > 0 || queueResult.failed > 0) {
      buildLogger.log("info", "websocket", `Runner ${runnerId} reconnected - processed queued commands`, {
        sent: queueResult.sent,
        failed: queueResult.failed,
        remaining: queueResult.remaining
      });
    }
    this.notifyRunnerConnected(runnerId);
    ws.on("pong", () => {
      const conn = this.runnerConnections.get(runnerId);
      if (conn) {
        conn.lastHeartbeat = Date.now();
      }
    });
    ws.on("message", async (data) => {
      try {
        const message = JSON.parse(data.toString());
        if (isRunnerEvent(message)) {
          const event = message;
          if (event.type === "runner-status") {
            const conn = this.runnerConnections.get(runnerId);
            if (conn) conn.lastHeartbeat = Date.now();
          }
          this.runnerTotalEvents++;
          await this.processRunnerEvent(event);
        }
      } catch (error) {
        this.runnerTotalErrors++;
        buildLogger.websocket.error("Failed to handle runner message", error, { runnerId });
      }
    });
    ws.on("close", (code) => {
      const conn = this.runnerConnections.get(runnerId);
      if (conn && conn.socket !== ws) {
        return;
      }
      buildLogger.websocket.runnerDisconnected(runnerId, code);
      if (conn) {
        clearInterval(conn.pingInterval);
      }
      this.runnerConnections.delete(runnerId);
      httpProxyManager.cancelRequestsForRunner(runnerId);
      hmrProxyManager.disconnectRunner(runnerId);
      this.cleanupRunnerProcesses(runnerId);
    });
    ws.on("error", (error) => {
      buildLogger.websocket.error("Runner socket error", error, { runnerId });
      this.runnerTotalErrors++;
      const conn = this.runnerConnections.get(runnerId);
      if (conn) {
        clearInterval(conn.pingInterval);
      }
      this.runnerConnections.delete(runnerId);
    });
  }
  /**
   * Process runner event - publish to event stream for WebSocket broadcasts
   * NOTE: Database writes now happen via HTTP from the runner (/api/runner-events, /api/build-events)
   */
  async processRunnerEvent(event) {
    if (httpProxyManager.processEvent(event)) {
      return;
    }
    if (hmrProxyManager.processEvent(event)) {
      return;
    }
    publishRunnerEvent(event);
  }
  /**
   * Queue a command for reliable delivery to a runner
   * Automatically retries if runner is disconnected, with configurable TTL
   */
  queueCommandToRunner(runnerId, command, options) {
    return commandQueue.enqueue(runnerId, command, options);
  }
  /**
   * Send a command to a specific runner (immediate, no queueing)
   */
  sendCommandToRunner(runnerId, command) {
    const connection = this.runnerConnections.get(runnerId);
    if (!connection || connection.socket.readyState !== WebSocket.OPEN) {
      buildLogger.websocket.runnerNotConnected(runnerId, command.type);
      return false;
    }
    try {
      buildLogger.websocket.commandSent(runnerId, command.type, false);
      connection.socket.send(JSON.stringify(command));
      this.runnerTotalCommands++;
      return true;
    } catch (error) {
      this.runnerTotalErrors++;
      buildLogger.websocket.error("Failed to send command to runner", error, { runnerId, commandType: command.type });
      return false;
    }
  }
  /**
   * List all connected runners with their status
   * @param userId - Optional user ID to filter runners (only show runners owned by this user)
   */
  listRunnerConnections(userId) {
    const now = Date.now();
    let connections = Array.from(this.runnerConnections.values());
    if (userId) {
      connections = connections.filter((conn) => conn.userId === userId);
    }
    return connections.map(({ id, lastHeartbeat, userId: connUserId }) => ({
      runnerId: id,
      lastHeartbeat,
      lastHeartbeatAge: now - lastHeartbeat,
      userId: connUserId
    }));
  }
  /**
   * Check if a specific runner is connected
   */
  isRunnerConnected(runnerId) {
    const conn = this.runnerConnections.get(runnerId);
    const isConnected = conn !== void 0 && conn.socket.readyState === WebSocket.OPEN;
    console.log(`[isRunnerConnected] Checking runner '${runnerId}':`, {
      hasConnection: conn !== void 0,
      socketState: conn?.socket.readyState,
      isOpen: conn?.socket.readyState === WebSocket.OPEN,
      result: isConnected,
      allRunners: Array.from(this.runnerConnections.keys())
    });
    return isConnected;
  }
  /**
   * Register a callback to be notified when runner status changes
   * This allows the app layer to emit project events when runners connect/disconnect
   */
  onRunnerStatusChange(callback) {
    this.onRunnerStatusChangeCallback = callback;
  }
  /**
   * Get runner metrics
   */
  getRunnerMetrics() {
    return {
      totalEvents: this.runnerTotalEvents,
      totalCommands: this.runnerTotalCommands,
      totalErrors: this.runnerTotalErrors,
      activeConnections: this.runnerConnections.size
    };
  }
  /**
   * Cleanup stale runner connections
   */
  cleanupStaleRunnerConnections() {
    const now = Date.now();
    for (const [runnerId, conn] of this.runnerConnections.entries()) {
      if (now - conn.lastHeartbeat > this.RUNNER_HEARTBEAT_TIMEOUT) {
        buildLogger.websocket.runnerStaleRemoved(runnerId);
        clearInterval(conn.pingInterval);
        conn.socket.close(1e3, "Heartbeat timeout");
        this.runnerConnections.delete(runnerId);
        this.cleanupRunnerProcesses(runnerId);
      }
    }
  }
  /**
   * Clean up running processes and update project statuses when a runner disconnects.
   * This ensures the UI shows accurate state when the runner is gone.
   */
  async cleanupRunnerProcesses(runnerId) {
    try {
      buildLogger.log("info", "websocket", `Cleaning up processes for disconnected runner: ${runnerId}`, { runnerId });
      const processes = await db.select({ projectId: runningProcesses.projectId }).from(runningProcesses).where(eq(runningProcesses.runnerId, runnerId));
      if (processes.length === 0) {
        buildLogger.log("debug", "websocket", `No running processes found for runner: ${runnerId}`, { runnerId });
        return;
      }
      const projectIds = processes.map((p) => p.projectId);
      buildLogger.log("info", "websocket", `Found ${projectIds.length} processes to clean up for runner: ${runnerId}`, {
        runnerId,
        projectIds
      });
      await db.delete(runningProcesses).where(eq(runningProcesses.runnerId, runnerId));
      const now = /* @__PURE__ */ new Date();
      for (const projectId of projectIds) {
        await db.update(projects).set({
          devServerStatus: "stopped",
          devServerStatusUpdatedAt: now,
          devServerPid: null
        }).where(eq(projects.id, projectId));
      }
      buildLogger.log("info", "websocket", `Cleaned up ${projectIds.length} processes for disconnected runner: ${runnerId}`, {
        runnerId,
        projectIds
      });
      if (this.onRunnerStatusChangeCallback) {
        try {
          this.onRunnerStatusChangeCallback(runnerId, false, projectIds);
        } catch (callbackError) {
          buildLogger.websocket.error("Runner status change callback failed", callbackError, { runnerId });
        }
      }
    } catch (error) {
      buildLogger.websocket.error("Failed to cleanup runner processes", error, { runnerId });
    }
  }
  /**
   * Notify app layer when a runner connects so projects can update their UI
   */
  async notifyRunnerConnected(runnerId) {
    if (!this.onRunnerStatusChangeCallback) return;
    try {
      const projectsWithRunner = await db.select({ id: projects.id }).from(projects).where(eq(projects.runnerId, runnerId));
      if (projectsWithRunner.length > 0) {
        const projectIds = projectsWithRunner.map((p) => p.id);
        buildLogger.log("info", "websocket", `Runner ${runnerId} connected - notifying ${projectIds.length} projects`, {
          runnerId,
          projectIds
        });
        this.onRunnerStatusChangeCallback(runnerId, true, projectIds);
      }
    } catch (error) {
      buildLogger.websocket.error("Failed to notify runner connected", error, { runnerId });
    }
  }
  /**
   * Handle messages from client (heartbeat, resubscribe, HMR, etc.)
   */
  async handleClientMessage(clientId, message) {
    const client = this.clients.get(clientId);
    if (!client) return;
    switch (message.type) {
      case "heartbeat":
        client.lastHeartbeat = Date.now();
        this.sendMessage(client.ws, { type: "heartbeat-ack", timestamp: Date.now() });
        break;
      case "subscribe": {
        const targetProjectId = typeof message.projectId === "string" ? message.projectId : "";
        const alreadyVerified = targetProjectId === client.projectId;
        if (targetProjectId && !alreadyVerified && !await this.canAccessProject(client.userId, targetProjectId)) {
          buildLogger.log("warn", "websocket", `Client ${clientId} denied subscribe to project ${targetProjectId}`);
          this.sendMessage(client.ws, { type: "error", error: "Forbidden", projectId: targetProjectId });
          break;
        }
        client.projectId = targetProjectId;
        client.sessionId = message.sessionId;
        buildLogger.websocket.clientSubscribed(clientId, targetProjectId);
        break;
      }
      case "get-state":
        this.sendCurrentState(client);
        break;
      // HMR Proxy Messages from frontend iframe
      case "hmr-connect":
        this.handleHmrConnect(clientId, client, message);
        break;
      case "hmr-send":
        this.handleHmrSend(message);
        break;
      case "hmr-disconnect":
        this.handleHmrDisconnect(clientId, client, message);
        break;
    }
  }
  /**
   * Handle HMR connect request from frontend
   */
  async handleHmrConnect(clientId, client, message) {
    const { connectionId, protocol } = message;
    if (!client.projectId) {
      this.sendMessage(client.ws, {
        type: "hmr-error",
        connectionId,
        error: "Not subscribed to a project"
      });
      return;
    }
    const target = await this.getHmrTargetForProject(client.projectId);
    if (!target) {
      this.sendMessage(client.ws, {
        type: "hmr-error",
        connectionId,
        error: "No runner available for project"
      });
      return;
    }
    const { runnerId: targetRunnerId, port } = target;
    if (!client.hmrConnections) {
      client.hmrConnections = /* @__PURE__ */ new Set();
    }
    client.hmrConnections.add(connectionId);
    hmrProxyManager.connect(
      connectionId,
      targetRunnerId,
      client.projectId,
      port,
      protocol,
      {
        onConnected: () => {
          this.sendMessage(client.ws, {
            type: "hmr-connected",
            connectionId
          });
        },
        onMessage: (msg) => {
          this.sendMessage(client.ws, {
            type: "hmr-message",
            connectionId,
            message: msg
          });
        },
        onDisconnected: (code, reason) => {
          client.hmrConnections?.delete(connectionId);
          this.sendMessage(client.ws, {
            type: "hmr-closed",
            connectionId,
            code,
            reason
          });
        },
        onError: (error) => {
          client.hmrConnections?.delete(connectionId);
          this.sendMessage(client.ws, {
            type: "hmr-error",
            connectionId,
            error
          });
        }
      }
    );
  }
  /**
   * Handle HMR send request from frontend
   */
  handleHmrSend(message) {
    const { connectionId, message: hmrMessage } = message;
    hmrProxyManager.send(connectionId, hmrMessage);
  }
  /**
   * Handle HMR disconnect request from frontend
   */
  handleHmrDisconnect(clientId, client, message) {
    const { connectionId } = message;
    client.hmrConnections?.delete(connectionId);
    hmrProxyManager.disconnect(connectionId);
  }
  /**
   * Resolve the HMR tunnel target (runner + dev server port) for a project.
   * The project's assigned runner must be connected and its dev server port
   * recorded - no fallback to "any runner".
   */
  async getHmrTargetForProject(projectId) {
    try {
      const rows = await db.select({ runnerId: projects.runnerId, devServerPort: projects.devServerPort }).from(projects).where(eq(projects.id, projectId)).limit(1);
      if (rows.length === 0) return null;
      const { runnerId, devServerPort } = rows[0];
      if (!runnerId || !devServerPort) return null;
      if (!this.runnerConnections.has(runnerId)) return null;
      return { runnerId, port: devServerPort };
    } catch (error) {
      buildLogger.websocket.error("Failed to resolve HMR target", error, { projectId });
      return null;
    }
  }
  /**
   * @deprecated Use discrete event broadcasts instead (broadcastBuildStarted, broadcastTodosUpdate,
   * broadcastToolCall, broadcastBuildComplete). This method broadcasts full state snapshots which
   * is inefficient for real-time updates. Kept for state recovery scenarios.
   */
  broadcastStateUpdate(projectId, sessionId, state) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "state-update",
      data: state,
      timestamp: Date.now()
    });
    if (batch.updates.length >= 10) {
      this.flushBatch(key);
    }
  }
  /**
   * Broadcast tool call event
   */
  broadcastToolCall(projectId, sessionId, toolCall) {
    const key = `${projectId}-${sessionId}`;
    if (toolCall.todoIndex < 0) {
      const subscriberCount = Array.from(this.clients.values()).filter(
        (client) => client.projectId === projectId
      ).length;
      buildLogger.websocket.broadcastToolCall(toolCall.name, toolCall.state, subscriberCount);
    }
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "tool-call",
      data: toolCall,
      timestamp: Date.now()
    });
    this.flushBatch(key);
  }
  /**
   * Broadcast build started event
   * This signals a new build has begun - flush immediately
   */
  broadcastBuildStarted(projectId, sessionId, buildId) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "build-started",
      data: { buildId, sessionId, projectId },
      timestamp: Date.now()
    });
    this.flushBatch(key);
  }
  /**
   * Broadcast todos update (when TodoWrite tool is called)
   * This establishes or updates the todo list - flush immediately
   * @param phase - Optional phase ('template' | 'build') to distinguish template setup from build tasks
   */
  broadcastTodosUpdate(projectId, sessionId, todos, activeTodoIndex, phase) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "todos-update",
      data: { todos, activeTodoIndex, phase },
      timestamp: Date.now()
    });
    this.flushBatch(key);
  }
  /**
   * Broadcast that a specific todo has completed (batch write finished)
   * This signals that all events for this todo have been persisted to DB
   */
  broadcastTodoCompleted(projectId, sessionId, todoIndex) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "todo-completed",
      data: { todoIndex, persisted: true },
      timestamp: Date.now()
    });
    this.flushBatch(key);
  }
  /**
   * Broadcast build completed/failed event
   * This is a terminal state event - flush immediately
   */
  broadcastBuildComplete(projectId, sessionId, status, summary) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "build-complete",
      data: { status, summary },
      timestamp: Date.now()
    });
    buildLogger.websocket.broadcastBuildComplete(projectId, sessionId, Array.from(this.clients.values()).filter(
      (client) => client.projectId === projectId
    ).length);
    this.flushBatch(key);
  }
  broadcastBuildSummary(projectId, sessionId, summary) {
    const key = `${projectId}-${sessionId}`;
    if (!this.pendingUpdates.has(key)) {
      this.pendingUpdates.set(key, {
        projectId,
        sessionId,
        updates: []
      });
    }
    const batch = this.pendingUpdates.get(key);
    batch.updates.push({
      type: "build-summary",
      data: { summary },
      timestamp: Date.now()
    });
    this.flushBatch(key);
  }
  /**
   * Process and send batched updates
   */
  processBatchedUpdates() {
    for (const [key, batch] of this.pendingUpdates.entries()) {
      this.flushBatch(key);
    }
  }
  /**
   * Flush a specific batch to clients
   */
  flushBatch(key) {
    const batch = this.pendingUpdates.get(key);
    if (!batch || batch.updates.length === 0) return;
    const { projectId, sessionId, updates } = batch;
    const subscribers2 = Array.from(this.clients.values()).filter(
      (client) => client.projectId === projectId && (!client.sessionId || client.sessionId === sessionId)
    );
    if (subscribers2.length === 0) {
      this.pendingUpdates.delete(key);
      return;
    }
    const message = {
      type: "batch-update",
      projectId,
      sessionId,
      updates,
      timestamp: Date.now()
    };
    subscribers2.forEach((client) => {
      this.sendMessage(client.ws, message);
    });
    this.pendingUpdates.delete(key);
  }
  /**
   * Send heartbeat to all connected clients
   */
  sendHeartbeats() {
    const now = Date.now();
    for (const [clientId, client] of this.clients.entries()) {
      if (now - client.lastHeartbeat > this.CLIENT_TIMEOUT) {
        buildLogger.websocket.clientTimeout(clientId);
        client.ws.close();
        this.clients.delete(clientId);
        continue;
      }
      this.sendMessage(client.ws, { type: "heartbeat", timestamp: now });
    }
  }
  /**
   * Send current state to a client (on reconnect)
   * Fetches the active build session from database and sends full state
   */
  async sendCurrentState(client) {
    if (!client.projectId) {
      this.sendMessage(client.ws, {
        type: "state-recovery",
        state: null,
        timestamp: Date.now()
      });
      return;
    }
    try {
      const sessions2 = await db.select().from(generationSessions).where(
        and(
          eq(generationSessions.projectId, client.projectId),
          eq(generationSessions.status, "active")
        )
      ).orderBy(desc(generationSessions.updatedAt)).limit(1);
      if (sessions2.length === 0) {
        const recentSessions = await db.select().from(generationSessions).where(eq(generationSessions.projectId, client.projectId)).orderBy(desc(generationSessions.updatedAt)).limit(1);
        if (recentSessions.length > 0 && recentSessions[0].rawState) {
          buildLogger.log("debug", "websocket", `Sending completed session state for project ${client.projectId}`);
          this.sendMessage(client.ws, {
            type: "state-recovery",
            state: recentSessions[0].rawState,
            sessionStatus: recentSessions[0].status,
            timestamp: Date.now()
          });
          return;
        }
        this.sendMessage(client.ws, {
          type: "state-recovery",
          state: null,
          timestamp: Date.now()
        });
        return;
      }
      const session = sessions2[0];
      if (session.rawState) {
        buildLogger.log("debug", "websocket", `Sending active session state for project ${client.projectId}`);
        this.sendMessage(client.ws, {
          type: "state-recovery",
          state: session.rawState,
          sessionId: session.id,
          sessionStatus: session.status,
          timestamp: Date.now()
        });
        return;
      }
      const [todos, toolCalls] = await Promise.all([
        db.select().from(generationTodos).where(eq(generationTodos.sessionId, session.id)).orderBy(generationTodos.todoIndex),
        db.select().from(generationToolCalls).where(eq(generationToolCalls.sessionId, session.id))
      ]);
      const toolsByTodo = {};
      for (const tool of toolCalls) {
        if (!toolsByTodo[tool.todoIndex]) {
          toolsByTodo[tool.todoIndex] = [];
        }
        toolsByTodo[tool.todoIndex].push(tool);
      }
      const activeTodoIndex = todos.findIndex((t) => t.status === "in_progress");
      const reconstructedState = {
        id: session.buildId,
        projectId: session.projectId,
        operationType: session.operationType || "continuation",
        todos: todos.map((t) => ({
          content: t.content,
          status: t.status,
          activeForm: t.activeForm || t.content
        })),
        toolsByTodo: Object.fromEntries(
          Object.entries(toolsByTodo).map(([idx, tools]) => [
            idx,
            tools.map((t) => ({
              id: t.toolCallId,
              name: t.name,
              input: t.input,
              output: t.output,
              state: t.state,
              startTime: t.startedAt,
              endTime: t.endedAt
            }))
          ])
        ),
        textByTodo: {},
        activeTodoIndex,
        // -1 if no todo is in_progress
        isActive: session.status === "active",
        startTime: session.startedAt,
        endTime: session.endedAt,
        buildSummary: session.summary,
        isAutoFix: session.isAutoFix,
        autoFixError: session.autoFixError
      };
      buildLogger.log("debug", "websocket", `Sending reconstructed state for project ${client.projectId}`);
      this.sendMessage(client.ws, {
        type: "state-recovery",
        state: reconstructedState,
        sessionId: session.id,
        sessionStatus: session.status,
        timestamp: Date.now()
      });
    } catch (error) {
      buildLogger.websocket.error("Failed to fetch state for recovery", error, { projectId: client.projectId });
      this.sendMessage(client.ws, {
        type: "state-recovery-failed",
        error: "Failed to recover state from database",
        timestamp: Date.now()
      });
    }
  }
  /**
   * Send message to a specific WebSocket
   */
  sendMessage(ws, message) {
    if (ws.readyState === WebSocket.OPEN) {
      try {
        ws.send(JSON.stringify(message));
      } catch (error) {
        buildLogger.websocket.error("Failed to send message", error);
      }
    }
  }
  /**
   * Generate unique client ID
   */
  generateClientId() {
    return `client-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  }
  /**
   * Get connection stats
   */
  getStats() {
    return {
      totalClients: this.clients.size,
      totalRunners: this.runnerConnections.size,
      pendingBatches: this.pendingUpdates.size,
      clientsByProject: this.getClientsByProject(),
      runners: this.listRunnerConnections(),
      runnerMetrics: this.getRunnerMetrics()
    };
  }
  /**
   * Get clients grouped by project
   */
  getClientsByProject() {
    const byProject = /* @__PURE__ */ new Map();
    for (const client of this.clients.values()) {
      const count = byProject.get(client.projectId) || 0;
      byProject.set(client.projectId, count + 1);
    }
    return Object.fromEntries(byProject);
  }
  /**
   * Shutdown WebSocket server
   */
  shutdown() {
    buildLogger.websocket.shutdown();
    if (this.batchInterval) {
      clearInterval(this.batchInterval);
    }
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
    }
    if (this.runnerCleanupInterval) {
      clearInterval(this.runnerCleanupInterval);
    }
    for (const client of this.clients.values()) {
      client.ws.close();
    }
    this.clients.clear();
    this.pendingUpdates.clear();
    for (const conn of this.runnerConnections.values()) {
      clearInterval(conn.pingInterval);
      conn.socket.close(1e3, "Server shutting down");
    }
    this.runnerConnections.clear();
    if (this.wss) {
      this.wss.close();
    }
    if (this.runnerWss) {
      this.runnerWss.close();
    }
    commandQueue.shutdown();
    buildLogger.websocket.shutdownComplete();
  }
  /**
   * Get command queue stats
   */
  getCommandQueueStats() {
    return commandQueue.getStats();
  }
};
if (!globalThis.__buildWebSocketServer) {
  globalThis.__buildWebSocketServer = new BuildWebSocketServer();
}
var buildWebSocketServer = globalThis.__buildWebSocketServer;

// src/lib/db/migrate.ts
import { drizzle as drizzle2 } from "drizzle-orm/node-postgres";
import { migrate } from "drizzle-orm/node-postgres/migrator";
import pg2 from "pg";
var { Pool: Pool2 } = pg2;
async function runMigrations(migrationsFolder = "./drizzle") {
  const connectionString = process.env.DATABASE_URL;
  if (!connectionString) {
    throw new Error(
      'DATABASE_URL is not set. Please configure your database connection:\n  - Run "hatchway init" to set up a Neon database\n  - Or set DATABASE_URL environment variable to your PostgreSQL connection string'
    );
  }
  const pool = new Pool2({
    connectionString,
    ssl: process.env.PGSSLMODE === "disable" ? false : { rejectUnauthorized: false }
  });
  const db2 = drizzle2(pool);
  console.log("\u{1F504} Running PostgreSQL database migrations...");
  try {
    await migrate(db2, { migrationsFolder });
    console.log("\u2705 Migrations completed successfully");
  } catch (error) {
    console.error("\u274C Migration failed:", error);
    throw error;
  } finally {
    await pool.end();
  }
}

// src/schemas/metadata.ts
import { z } from "zod";
var ProjectMetadataSchema = z.object({
  slug: z.string().describe("URL-friendly project identifier (lowercase, hyphens)"),
  friendlyName: z.string().describe("Human-readable project name"),
  description: z.string().describe("Brief description of what the project does"),
  icon: z.enum([
    "Folder",
    "Code",
    "Layout",
    "Database",
    "Zap",
    "Globe",
    "Lock",
    "Users",
    "ShoppingCart",
    "Calendar",
    "MessageSquare",
    "FileText",
    "Image",
    "Music",
    "Video",
    "CheckCircle",
    "Star"
  ]).describe("Icon name from available Lucide icons")
});
var TemplateAnalysisSchema = z.object({
  templateId: z.string().describe("ID of the selected template"),
  reasoning: z.string().describe("Brief explanation of why this template was chosen"),
  confidence: z.number().min(0).max(1).describe("Confidence score from 0.0 to 1.0")
});
var ProjectNamingSchema = z.object({
  slug: z.string().describe("URL-friendly project identifier (lowercase, hyphens, 2-4 words)"),
  friendlyName: z.string().describe("Human-readable project name (Title Case, 2-5 words)")
});
var AVAILABLE_ICONS = [
  "Folder",
  "Code",
  "Layout",
  "Database",
  "Zap",
  "Globe",
  "Lock",
  "Users",
  "ShoppingCart",
  "Calendar",
  "MessageSquare",
  "FileText",
  "Image",
  "Music",
  "Video",
  "CheckCircle",
  "Star"
];
export {
  AVAILABLE_ICONS,
  CLAUDE_SYSTEM_PROMPT,
  CODEX_SYSTEM_PROMPT,
  DEFAULT_AGENT_ID,
  DEFAULT_CLAUDE_MODEL_ID,
  DEFAULT_OPENCODE_MODEL_ID,
  GITHUB_CHAT_MESSAGES,
  LEGACY_MODEL_MAP,
  MODEL_METADATA,
  NEONDB_CHAT_MESSAGES,
  ProjectMetadataSchema,
  ProjectNamingSchema,
  TemplateAnalysisSchema,
  buildLogger,
  buildWebSocketServer,
  db,
  getDb,
  getModelLabel,
  initializeDatabase,
  isRunnerCommand,
  isRunnerEvent,
  normalizeModelId,
  parseModelId,
  resetDatabase,
  resolveAgentStrategy,
  runMigrations,
  setTemplatesPath
};
//# sourceMappingURL=index.js.map